"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoodUnit = exports.GoodOrderBy = exports.GeoIndicationOrderBy = exports.FrequentSearchSystemType = exports.FrequentSearchStatus = exports.FrequentSearchCollection = exports.FoodServiceType = exports.FoodServiceOrderBy = exports.FinalPosition = exports.ExclusionReason = exports.EuIndication = exports.EmailDomainOrderBy = exports.EmailDomainAction = exports.EditorialSectionOrderBy = exports.EditorialBrand = exports.DistributionMode = exports.CouponType = exports.CouponOrderBy = exports.CountryOrderByEnum = exports.Contact_Items_Active_Access__C_Enum = exports.CompanyRevenueRange = exports.CompanyOwnership = exports.CompanyOrderBy = exports.CompanyLevelEnum = exports.CompanyIndustry = exports.CompanyGroupType = exports.CompanyGroupOrderBy = exports.CompaniesTypeEnum = exports.Channel = exports.Capability = exports.CandidacyRatingOrderBy = exports.CandidacyOrderBy = exports.CampaignMember_Esito_Campaign__C_Enum = exports.BranchType = exports.BooleanEnum = exports.BannerViewType = exports.BannerOrderBy = exports.BannerLayout = exports.AwardVisibility = exports.AwardStatus = exports.AwardRoles = exports.AwardOrderBy = exports.AwardOptionFlag = exports.AtecoCodeOrderBy = exports.AccountType = exports.Account_Settore2__C_Enum = exports.AccessRole = exports.Abbonamento_Periodo__C_Provenienza__C_Enum = exports.Abbonamento__C_Rivista__C_Enum = exports.Abbonamento__C_Package__C_Enum = void 0;
exports.WidgetStyleType = exports.WidgetStyleColor = exports.WidgetOrderBy = exports.WidgetLocation = exports.VisibilityType = exports.VisibilityRole = exports.VisibilityRelations = exports.UserStatus = exports.UserRole = exports.UserOrderBy = exports.UserObjectSubscriptionFlag = exports.UserNoteCollection = exports.TransformationLevel = exports.TargetSite = exports.TargetMedia = exports.StateProvinceOrderByEnum = exports.SocialType = exports.ServiceType = exports.ServiceOrderBy = exports.SampleRequestStatus = exports.RetailerType = exports.RetailerOrderBy = exports.QuoteAccountType = exports.Quote_Status_Enum = exports.Quote_Condizioni_Di_Pagamento__C_Enum = exports.Quote_BillingCountryCode_Enum = exports.QuestionSetRequest = exports.Product2_Tipologia__C_Enum = exports.Product2_Famiglia__C_Enum = exports.Product2_Brand_Area__C_Enum = exports.Product2_Brand__C_EnumFiltered = exports.PricePositioning = exports.PricebookEntryOrderBy = exports.Preservation = exports.ObjectHistoryCollection = exports.ObjectHistoryAction = exports.NewsStatus = exports.NewsSource = exports.NewsletterAcceptedFlag = exports.MediaType = exports.MediaOrderBy = exports.MagazineOrderBy = exports.ItalianIndication = exports.InternalCapability = exports.InputTemplate = exports.Indirizzo__C_Tipo__C_Enum = exports.HighlightReasons = exports.GridSize = void 0;
/** SF picklist */
var Abbonamento__C_Package__C_Enum;
(function (Abbonamento__C_Package__C_Enum) {
    /** DOLCESALATO_Cartacei e Sfogliabili Digitali */
    Abbonamento__C_Package__C_Enum["DolcesalatoCartaceiESfogliabiliDigitali"] = "DOLCESALATO_CARTACEI_E_SFOGLIABILI_DIGITALI";
    /** DOLCESALATO_Sfogliabili Digitali */
    Abbonamento__C_Package__C_Enum["DolcesalatoSfogliabiliDigitali"] = "DOLCESALATO_SFOGLIABILI_DIGITALI";
    /** FOOD_Cartacei e Sfogliabili Digitali */
    Abbonamento__C_Package__C_Enum["FoodCartaceiESfogliabiliDigitali"] = "FOOD_CARTACEI_E_SFOGLIABILI_DIGITALI";
    /** FOOD_Sfogliabili Digitali */
    Abbonamento__C_Package__C_Enum["FoodSfogliabiliDigitali"] = "FOOD_SFOGLIABILI_DIGITALI";
    /** FOODSERVICE_Cartacei e Sfogliabili Digitali */
    Abbonamento__C_Package__C_Enum["FoodserviceCartaceiESfogliabiliDigitali"] = "FOODSERVICE_CARTACEI_E_SFOGLIABILI_DIGITALI";
    /** FOODSERVICE_Sfogliabili Digitali */
    Abbonamento__C_Package__C_Enum["FoodserviceSfogliabiliDigitali"] = "FOODSERVICE_SFOGLIABILI_DIGITALI";
    /** ITALIANFOOD.NET_Cartacei e Sfogliabili Digitali */
    Abbonamento__C_Package__C_Enum["ItalianfoodNetCartaceiESfogliabiliDigitali"] = "ITALIANFOOD_NET_CARTACEI_E_SFOGLIABILI_DIGITALI";
    /** ITALIANFOOD.NET_Sfogliabili Digitali */
    Abbonamento__C_Package__C_Enum["ItalianfoodNetSfogliabiliDigitali"] = "ITALIANFOOD_NET_SFOGLIABILI_DIGITALI";
    /** BB - Premium */
    Abbonamento__C_Package__C_Enum["BbPremium"] = "BB_PREMIUM";
    /** BB - Basic */
    Abbonamento__C_Package__C_Enum["BbBasic"] = "BB_BASIC";
})(Abbonamento__C_Package__C_Enum || (exports.Abbonamento__C_Package__C_Enum = Abbonamento__C_Package__C_Enum = {}));
/** SF picklist */
var Abbonamento__C_Rivista__C_Enum;
(function (Abbonamento__C_Rivista__C_Enum) {
    /** FOOD */
    Abbonamento__C_Rivista__C_Enum["Food"] = "FOOD";
    /** Dolcesalato */
    Abbonamento__C_Rivista__C_Enum["Dolcesalato"] = "DOLCESALATO";
    /** Bar Business */
    Abbonamento__C_Rivista__C_Enum["BarBusiness"] = "BAR_BUSINESS";
    /** ITALIANFOOD.NET */
    Abbonamento__C_Rivista__C_Enum["ItalianfoodNet"] = "ITALIANFOOD_NET";
    /** Food Service */
    Abbonamento__C_Rivista__C_Enum["FoodService"] = "FOOD_SERVICE";
})(Abbonamento__C_Rivista__C_Enum || (exports.Abbonamento__C_Rivista__C_Enum = Abbonamento__C_Rivista__C_Enum = {}));
/** SF picklist */
var Abbonamento_Periodo__C_Provenienza__C_Enum;
(function (Abbonamento_Periodo__C_Provenienza__C_Enum) {
    /** CC postale */
    Abbonamento_Periodo__C_Provenienza__C_Enum["CcPostale"] = "CC_POSTALE";
    /** Paypal */
    Abbonamento_Periodo__C_Provenienza__C_Enum["Paypal"] = "PAYPAL";
    /** Contanti */
    Abbonamento_Periodo__C_Provenienza__C_Enum["Contanti"] = "CONTANTI";
    /** Carta di credito */
    Abbonamento_Periodo__C_Provenienza__C_Enum["CartaDiCredito"] = "CARTA_DI_CREDITO";
    /** Bonifico Bancario */
    Abbonamento_Periodo__C_Provenienza__C_Enum["BonificoBancario"] = "BONIFICO_BANCARIO";
    /** Omaggio Aziendale */
    Abbonamento_Periodo__C_Provenienza__C_Enum["OmaggioAziendale"] = "OMAGGIO_AZIENDALE";
    /** Assegno Bancario */
    Abbonamento_Periodo__C_Provenienza__C_Enum["AssegnoBancario"] = "ASSEGNO_BANCARIO";
    /** Omaggio con scadenza */
    Abbonamento_Periodo__C_Provenienza__C_Enum["OmaggioConScadenza"] = "OMAGGIO_CON_SCADENZA";
    /** Omaggio Paolo */
    Abbonamento_Periodo__C_Provenienza__C_Enum["OmaggioPaolo"] = "OMAGGIO_PAOLO";
    /** Omaggio Davide */
    Abbonamento_Periodo__C_Provenienza__C_Enum["OmaggioDavide"] = "OMAGGIO_DAVIDE";
    /** Omaggio Valentina */
    Abbonamento_Periodo__C_Provenienza__C_Enum["OmaggioValentina"] = "OMAGGIO_VALENTINA";
    /** Omaggio Cristina */
    Abbonamento_Periodo__C_Provenienza__C_Enum["OmaggioCristina"] = "OMAGGIO_CRISTINA";
    /** Omaggio Nicola */
    Abbonamento_Periodo__C_Provenienza__C_Enum["OmaggioNicola"] = "OMAGGIO_NICOLA";
    /** Omaggio Agente */
    Abbonamento_Periodo__C_Provenienza__C_Enum["OmaggioAgente"] = "OMAGGIO_AGENTE";
    /** Omaggio Annabella */
    Abbonamento_Periodo__C_Provenienza__C_Enum["OmaggioAnnabella"] = "OMAGGIO_ANNABELLA";
    /** Omaggio Fochi */
    Abbonamento_Periodo__C_Provenienza__C_Enum["OmaggioFochi"] = "OMAGGIO_FOCHI";
    /** Omaggio Bosini */
    Abbonamento_Periodo__C_Provenienza__C_Enum["OmaggioBosini"] = "OMAGGIO_BOSINI";
})(Abbonamento_Periodo__C_Provenienza__C_Enum || (exports.Abbonamento_Periodo__C_Provenienza__C_Enum = Abbonamento_Periodo__C_Provenienza__C_Enum = {}));
/** Per accesso in base al role. Flags */
var AccessRole;
(function (AccessRole) {
    AccessRole["Anonymus"] = "ANONYMUS";
    AccessRole["Internal"] = "INTERNAL";
    AccessRole["Producer"] = "PRODUCER";
    AccessRole["Buyer"] = "BUYER";
    AccessRole["BuyerPlItalia"] = "BUYER_PL_ITALIA";
    AccessRole["Foodservice"] = "FOODSERVICE";
    AccessRole["Shopworker"] = "SHOPWORKER";
    AccessRole["Service"] = "SERVICE";
    AccessRole["Consumer"] = "CONSUMER";
})(AccessRole || (exports.AccessRole = AccessRole = {}));
/** SF picklist */
var Account_Settore2__C_Enum;
(function (Account_Settore2__C_Enum) {
    /** Industria */
    Account_Settore2__C_Enum["Industria"] = "INDUSTRIA";
    /** Retail */
    Account_Settore2__C_Enum["Retail"] = "RETAIL";
    /** Editoria */
    Account_Settore2__C_Enum["Editoria"] = "EDITORIA";
    /** Servizi */
    Account_Settore2__C_Enum["Servizi"] = "SERVIZI";
    /** Freelancer */
    Account_Settore2__C_Enum["Freelancer"] = "FREELANCER";
    /** Food Service */
    Account_Settore2__C_Enum["FoodService"] = "FOOD_SERVICE";
    /** Punto Vendita */
    Account_Settore2__C_Enum["PuntoVendita"] = "PUNTO_VENDITA";
    /** Istituzioni */
    Account_Settore2__C_Enum["Istituzioni"] = "ISTITUZIONI";
})(Account_Settore2__C_Enum || (exports.Account_Settore2__C_Enum = Account_Settore2__C_Enum = {}));
var AccountType;
(function (AccountType) {
    AccountType["Industry"] = "INDUSTRY";
    AccountType["RetailPl"] = "RETAIL_PL";
    AccountType["RetailNoPl"] = "RETAIL_NO_PL";
    AccountType["Institution"] = "INSTITUTION";
    AccountType["Service"] = "SERVICE";
})(AccountType || (exports.AccountType = AccountType = {}));
var AtecoCodeOrderBy;
(function (AtecoCodeOrderBy) {
    AtecoCodeOrderBy["Code"] = "code";
    AtecoCodeOrderBy["Description"] = "description";
})(AtecoCodeOrderBy || (exports.AtecoCodeOrderBy = AtecoCodeOrderBy = {}));
/** // TODO */
var AwardOptionFlag;
(function (AwardOptionFlag) {
    AwardOptionFlag["EanRequired"] = "EAN_REQUIRED";
    AwardOptionFlag["LaunchdateRequired"] = "LAUNCHDATE_REQUIRED";
    AwardOptionFlag["ExtramediaRequired"] = "EXTRAMEDIA_REQUIRED";
    AwardOptionFlag["CompanyLogoprintRequired"] = "COMPANY_LOGOPRINT_REQUIRED";
    AwardOptionFlag["SignedContractRequired"] = "SIGNED_CONTRACT_REQUIRED";
    AwardOptionFlag["GalleryEnabled"] = "GALLERY_ENABLED";
    AwardOptionFlag["IngredientsImageRequired"] = "INGREDIENTS_IMAGE_REQUIRED";
})(AwardOptionFlag || (exports.AwardOptionFlag = AwardOptionFlag = {}));
var AwardOrderBy;
(function (AwardOrderBy) {
    AwardOrderBy["Name"] = "name";
    AwardOrderBy["Edition"] = "edition";
    AwardOrderBy["Year"] = "year";
    AwardOrderBy["Status"] = "status";
    AwardOrderBy["CandidaciesCloseAt"] = "candidaciesCloseAt";
    AwardOrderBy["VotesCloseAt"] = "votesCloseAt";
})(AwardOrderBy || (exports.AwardOrderBy = AwardOrderBy = {}));
/** Ruoli che gli utenti (invitati) possono ricoprire per un premio. Flags */
var AwardRoles;
(function (AwardRoles) {
    AwardRoles["SpecialJuror"] = "SPECIAL_JUROR";
    AwardRoles["Speaker"] = "SPEAKER";
    AwardRoles["SpecialGuest"] = "SPECIAL_GUEST";
})(AwardRoles || (exports.AwardRoles = AwardRoles = {}));
/** Award's possible statues */
var AwardStatus;
(function (AwardStatus) {
    AwardStatus["Draft"] = "DRAFT";
    AwardStatus["CandidancyOpen"] = "CANDIDANCY_OPEN";
    AwardStatus["CandidancyClosed"] = "CANDIDANCY_CLOSED";
    AwardStatus["VotingOpen"] = "VOTING_OPEN";
    AwardStatus["VotingClosed"] = "VOTING_CLOSED";
    AwardStatus["Concluded"] = "CONCLUDED";
})(AwardStatus || (exports.AwardStatus = AwardStatus = {}));
/** Award's possible visibility statues */
var AwardVisibility;
(function (AwardVisibility) {
    AwardVisibility["Vote"] = "VOTE";
    AwardVisibility["Showcase"] = "SHOWCASE";
})(AwardVisibility || (exports.AwardVisibility = AwardVisibility = {}));
/** Per determinare il mediaType faccio : mediaType = BannerLayout2MediaType[bannerEntity.layout] */
var BannerLayout;
(function (BannerLayout) {
    BannerLayout["Full"] = "Full";
    BannerLayout["SidedBoxWithFrequentSearch"] = "SidedBoxWithFrequentSearch";
    BannerLayout["SmallImageOnly"] = "SmallImageOnly";
    BannerLayout["LeaderboardImageOnly"] = "LeaderboardImageOnly";
    BannerLayout["PopupImageOnly"] = "PopupImageOnly";
    BannerLayout["DirectoryCard"] = "DirectoryCard";
    BannerLayout["Popup"] = "Popup";
    BannerLayout["Toaster"] = "Toaster";
    BannerLayout["ImpiantoMezza"] = "Impianto_Mezza";
    BannerLayout["ImpiantoMezzaVerticale"] = "Impianto_MezzaVerticale";
    BannerLayout["ImpiantoIntera"] = "Impianto_Intera";
    BannerLayout["ImpiantoBattente"] = "Impianto_Battente";
    BannerLayout["PubbliRedazionaleSingola"] = "PubbliRedazionale_Singola";
    BannerLayout["PubbliRedazionaleDoppia"] = "PubbliRedazionale_Doppia";
})(BannerLayout || (exports.BannerLayout = BannerLayout = {}));
var BannerOrderBy;
(function (BannerOrderBy) {
    BannerOrderBy["Name"] = "name";
    BannerOrderBy["StartDate"] = "startDate";
    BannerOrderBy["ExpirationDate"] = "expirationDate";
    BannerOrderBy["IsValidated"] = "isValidated";
    BannerOrderBy["IsSfAbandoned"] = "isSfAbandoned";
    BannerOrderBy["DeadlineDate"] = "deadlineDate";
    BannerOrderBy["Size"] = "size";
    BannerOrderBy["Media"] = "Media";
})(BannerOrderBy || (exports.BannerOrderBy = BannerOrderBy = {}));
var BannerViewType;
(function (BannerViewType) {
    BannerViewType["Impression"] = "IMPRESSION";
    BannerViewType["Click"] = "CLICK";
})(BannerViewType || (exports.BannerViewType = BannerViewType = {}));
/** Map boolean to enum for xxSetStatus usage */
var BooleanEnum;
(function (BooleanEnum) {
    BooleanEnum["False"] = "FALSE";
    BooleanEnum["True"] = "TRUE";
})(BooleanEnum || (exports.BooleanEnum = BooleanEnum = {}));
var BranchType;
(function (BranchType) {
    BranchType["ManufacturingPlant"] = "MANUFACTURING_PLANT";
    BranchType["PoBox"] = "PO_BOX";
    BranchType["LogisticDepartment"] = "LOGISTIC_DEPARTMENT";
    BranchType["SalesDepartment"] = "SALES_DEPARTMENT";
})(BranchType || (exports.BranchType = BranchType = {}));
/** SF picklist */
var CampaignMember_Esito_Campaign__C_Enum;
(function (CampaignMember_Esito_Campaign__C_Enum) {
    /** Assente */
    CampaignMember_Esito_Campaign__C_Enum["Assente"] = "ASSENTE";
    /** Presente */
    CampaignMember_Esito_Campaign__C_Enum["Presente"] = "PRESENTE";
    /** Presente solo convegno */
    CampaignMember_Esito_Campaign__C_Enum["PresenteSoloConvegno"] = "PRESENTE_SOLO_CONVEGNO";
    /** Presente solo cena */
    CampaignMember_Esito_Campaign__C_Enum["PresenteSoloCena"] = "PRESENTE_SOLO_CENA";
    /** Interessato */
    CampaignMember_Esito_Campaign__C_Enum["Interessato"] = "INTERESSATO";
    /** Non Interessato */
    CampaignMember_Esito_Campaign__C_Enum["NonInteressato"] = "NON_INTERESSATO";
})(CampaignMember_Esito_Campaign__C_Enum || (exports.CampaignMember_Esito_Campaign__C_Enum = CampaignMember_Esito_Campaign__C_Enum = {}));
var CandidacyOrderBy;
(function (CandidacyOrderBy) {
    CandidacyOrderBy["Name"] = "name";
    CandidacyOrderBy["AwardId"] = "awardId";
    CandidacyOrderBy["AwardCategoryId"] = "awardCategoryId";
})(CandidacyOrderBy || (exports.CandidacyOrderBy = CandidacyOrderBy = {}));
var CandidacyRatingOrderBy;
(function (CandidacyRatingOrderBy) {
    CandidacyRatingOrderBy["User"] = "User";
    CandidacyRatingOrderBy["Candidacy"] = "Candidacy";
    CandidacyRatingOrderBy["LocalId"] = "localId";
})(CandidacyRatingOrderBy || (exports.CandidacyRatingOrderBy = CandidacyRatingOrderBy = {}));
/** User possible managing Capabilities */
var Capability;
(function (Capability) {
    Capability["Edit"] = "EDIT";
    Capability["Account"] = "ACCOUNT";
    Capability["Purchase"] = "PURCHASE";
    Capability["Manage"] = "MANAGE";
})(Capability || (exports.Capability = Capability = {}));
var Channel;
(function (Channel) {
    Channel["Retail"] = "RETAIL";
    Channel["Foodservice"] = "FOODSERVICE";
    Channel["GourmetShops"] = "GOURMET_SHOPS";
    Channel["Wholesaler"] = "WHOLESALER";
})(Channel || (exports.Channel = Channel = {}));
/** Companies possible types */
var CompaniesTypeEnum;
(function (CompaniesTypeEnum) {
    CompaniesTypeEnum["Company"] = "Company";
    CompaniesTypeEnum["Brand"] = "Brand";
})(CompaniesTypeEnum || (exports.CompaniesTypeEnum = CompaniesTypeEnum = {}));
var CompanyGroupOrderBy;
(function (CompanyGroupOrderBy) {
    CompanyGroupOrderBy["Name"] = "name";
    CompanyGroupOrderBy["Type"] = "type";
})(CompanyGroupOrderBy || (exports.CompanyGroupOrderBy = CompanyGroupOrderBy = {}));
/** CompanyGroup possible types */
var CompanyGroupType;
(function (CompanyGroupType) {
    CompanyGroupType["AssociazioneDiCategoria"] = "ASSOCIAZIONE_DI_CATEGORIA";
    CompanyGroupType["CameraDiCommercioEntePromozione"] = "CAMERA_DI_COMMERCIO_ENTE_PROMOZIONE";
    CompanyGroupType["ConsorziDiTutela"] = "CONSORZI_DI_TUTELA";
    CompanyGroupType["ConsorziPrivati"] = "CONSORZI_PRIVATI";
    CompanyGroupType["IstituzioneCulturale"] = "ISTITUZIONE_CULTURALE";
    CompanyGroupType["OrganiStatali"] = "ORGANI_STATALI";
    CompanyGroupType["ScuoleEUniversit"] = "SCUOLE_E_UNIVERSIT";
})(CompanyGroupType || (exports.CompanyGroupType = CompanyGroupType = {}));
/** Company possible industries */
var CompanyIndustry;
(function (CompanyIndustry) {
    CompanyIndustry["IndustriaAlimentare"] = "INDUSTRIA_ALIMENTARE";
    CompanyIndustry["IndustriaBeniDiConsumoNonFood"] = "INDUSTRIA_BENI_DI_CONSUMO_NON_FOOD";
    CompanyIndustry["IndustriaImpiantiIndAlimArredamenti"] = "INDUSTRIA_IMPIANTI_IND_ALIM_ARREDAMENTI";
    CompanyIndustry["IndustriaPackAlimTrasformazione"] = "INDUSTRIA_PACK_ALIM_TRASFORMAZIONE";
    CompanyIndustry["IstituzioneCulturale"] = "ISTITUZIONE_CULTURALE";
})(CompanyIndustry || (exports.CompanyIndustry = CompanyIndustry = {}));
/** Company possible level types */
var CompanyLevelEnum;
(function (CompanyLevelEnum) {
    CompanyLevelEnum["Hidden"] = "HIDDEN";
    CompanyLevelEnum["Free"] = "FREE";
    CompanyLevelEnum["PaidL1"] = "PAID_L1";
    CompanyLevelEnum["PaidL2"] = "PAID_L2";
    CompanyLevelEnum["PaidL3"] = "PAID_L3";
    CompanyLevelEnum["PaidL4"] = "PAID_L4";
})(CompanyLevelEnum || (exports.CompanyLevelEnum = CompanyLevelEnum = {}));
var CompanyOrderBy;
(function (CompanyOrderBy) {
    CompanyOrderBy["Name"] = "name";
    CompanyOrderBy["Industry"] = "industry";
})(CompanyOrderBy || (exports.CompanyOrderBy = CompanyOrderBy = {}));
/** Company possible ownership types */
var CompanyOwnership;
(function (CompanyOwnership) {
    CompanyOwnership["FamilyBusiness"] = "FAMILY_BUSINESS";
    CompanyOwnership["MultinationalCorporation"] = "MULTINATIONAL_CORPORATION";
    CompanyOwnership["PrivateEquity"] = "PRIVATE_EQUITY";
    CompanyOwnership["Cooperative"] = "COOPERATIVE";
})(CompanyOwnership || (exports.CompanyOwnership = CompanyOwnership = {}));
/** Company revenue ranges */
var CompanyRevenueRange;
(function (CompanyRevenueRange) {
    /** Under 30000000 */
    CompanyRevenueRange["Before"] = "BEFORE";
    /** Over 100000000 */
    CompanyRevenueRange["After"] = "AFTER";
    /** Range 30000000-100000000 */
    CompanyRevenueRange["Range_0"] = "RANGE_0";
})(CompanyRevenueRange || (exports.CompanyRevenueRange = CompanyRevenueRange = {}));
/** SF picklist */
var Contact_Items_Active_Access__C_Enum;
(function (Contact_Items_Active_Access__C_Enum) {
    /** DS | Rivista | Periodico e Speciali */
    Contact_Items_Active_Access__C_Enum["DsRivistaPeriodicoESpeciali"] = "DS_RIVISTA_PERIODICO_E_SPECIALI";
    /** DS | Digitale | Periodico Completo */
    Contact_Items_Active_Access__C_Enum["DsDigitalePeriodicoCompleto"] = "DS_DIGITALE_PERIODICO_COMPLETO";
    /** FOOD | Rivista | Periodico e Speciali */
    Contact_Items_Active_Access__C_Enum["FoodRivistaPeriodicoESpeciali"] = "FOOD_RIVISTA_PERIODICO_E_SPECIALI";
    /** FOOD | Digitale | Periodico Completo */
    Contact_Items_Active_Access__C_Enum["FoodDigitalePeriodicoCompleto"] = "FOOD_DIGITALE_PERIODICO_COMPLETO";
    /** FS | Rivista | Periodico e Speciali */
    Contact_Items_Active_Access__C_Enum["FsRivistaPeriodicoESpeciali"] = "FS_RIVISTA_PERIODICO_E_SPECIALI";
    /** FS | Digitale | Periodico Completo */
    Contact_Items_Active_Access__C_Enum["FsDigitalePeriodicoCompleto"] = "FS_DIGITALE_PERIODICO_COMPLETO";
    /** IFNET | Rivista | Periodico e Speciali */
    Contact_Items_Active_Access__C_Enum["IfnetRivistaPeriodicoESpeciali"] = "IFNET_RIVISTA_PERIODICO_E_SPECIALI";
    /** IFNET | Digitale | Periodico Completo */
    Contact_Items_Active_Access__C_Enum["IfnetDigitalePeriodicoCompleto"] = "IFNET_DIGITALE_PERIODICO_COMPLETO";
})(Contact_Items_Active_Access__C_Enum || (exports.Contact_Items_Active_Access__C_Enum = Contact_Items_Active_Access__C_Enum = {}));
var CountryOrderByEnum;
(function (CountryOrderByEnum) {
    CountryOrderByEnum["Name"] = "name";
    CountryOrderByEnum["Code"] = "code";
    CountryOrderByEnum["Area"] = "area";
    CountryOrderByEnum["ContinentMc"] = "continentMc";
})(CountryOrderByEnum || (exports.CountryOrderByEnum = CountryOrderByEnum = {}));
var CouponOrderBy;
(function (CouponOrderBy) {
    CouponOrderBy["Name"] = "name";
    CouponOrderBy["StartDate"] = "startDate";
    CouponOrderBy["ExpirationDate"] = "expirationDate";
})(CouponOrderBy || (exports.CouponOrderBy = CouponOrderBy = {}));
var CouponType;
(function (CouponType) {
    CouponType["Fix"] = "FIX";
    CouponType["Percentage"] = "PERCENTAGE";
})(CouponType || (exports.CouponType = CouponType = {}));
var DistributionMode;
(function (DistributionMode) {
    DistributionMode["Direct"] = "DIRECT";
    DistributionMode["Distributor"] = "DISTRIBUTOR";
    DistributionMode["LocalBranch"] = "LOCAL_BRANCH";
    DistributionMode["Broker"] = "BROKER";
})(DistributionMode || (exports.DistributionMode = DistributionMode = {}));
/** TODO */
var EditorialBrand;
(function (EditorialBrand) {
    EditorialBrand["Barbusiness"] = "BARBUSINESS";
    EditorialBrand["Foodweb"] = "FOODWEB";
    EditorialBrand["Ifn"] = "IFN";
    EditorialBrand["CmAttuali"] = "CM_ATTUALI";
    EditorialBrand["Goods4Hub"] = "GOODS4HUB";
    EditorialBrand["Food"] = "FOOD";
    EditorialBrand["Foodservice"] = "FOODSERVICE";
    EditorialBrand["Dolcesalato"] = "DOLCESALATO";
})(EditorialBrand || (exports.EditorialBrand = EditorialBrand = {}));
var EditorialSectionOrderBy;
(function (EditorialSectionOrderBy) {
    EditorialSectionOrderBy["Name"] = "name";
    EditorialSectionOrderBy["EditorialBrand"] = "editorialBrand";
})(EditorialSectionOrderBy || (exports.EditorialSectionOrderBy = EditorialSectionOrderBy = {}));
/** Automatic internal action performed */
var EmailDomainAction;
(function (EmailDomainAction) {
    EmailDomainAction["WaitAndNotify"] = "WAIT_AND_NOTIFY";
    EmailDomainAction["Accept"] = "ACCEPT";
    EmailDomainAction["ConsumerOnly"] = "CONSUMER_ONLY";
    EmailDomainAction["ShopworkerOnly"] = "SHOPWORKER_ONLY";
})(EmailDomainAction || (exports.EmailDomainAction = EmailDomainAction = {}));
var EmailDomainOrderBy;
(function (EmailDomainOrderBy) {
    EmailDomainOrderBy["EmailDomain"] = "emailDomain";
    EmailDomainOrderBy["AccountType"] = "accountType";
    EmailDomainOrderBy["Action"] = "action";
})(EmailDomainOrderBy || (exports.EmailDomainOrderBy = EmailDomainOrderBy = {}));
/** EU Indications */
var EuIndication;
(function (EuIndication) {
    EuIndication["Pdo"] = "PDO";
    EuIndication["Pgi"] = "PGI";
    EuIndication["Tsg"] = "TSG";
})(EuIndication || (exports.EuIndication = EuIndication = {}));
/** Possible exclusion reasons */
var ExclusionReason;
(function (ExclusionReason) {
    ExclusionReason["Other"] = "OTHER";
    ExclusionReason["Price"] = "PRICE";
    ExclusionReason["Packaging"] = "PACKAGING";
    ExclusionReason["Logistic"] = "LOGISTIC";
    ExclusionReason["Certifications"] = "CERTIFICATIONS";
    ExclusionReason["ProductiveCapability"] = "PRODUCTIVE_CAPABILITY";
})(ExclusionReason || (exports.ExclusionReason = ExclusionReason = {}));
/** Possible final positions for award candidacies */
var FinalPosition;
(function (FinalPosition) {
    FinalPosition["Winner"] = "WINNER";
    FinalPosition["Second"] = "SECOND";
    FinalPosition["Third"] = "THIRD";
})(FinalPosition || (exports.FinalPosition = FinalPosition = {}));
var FoodServiceOrderBy;
(function (FoodServiceOrderBy) {
    FoodServiceOrderBy["Name"] = "name";
    FoodServiceOrderBy["Type"] = "type";
})(FoodServiceOrderBy || (exports.FoodServiceOrderBy = FoodServiceOrderBy = {}));
/** FoodService possible types */
var FoodServiceType;
(function (FoodServiceType) {
    FoodServiceType["Agriturismo"] = "AGRITURISMO";
    FoodServiceType["Asporto"] = "ASPORTO";
    FoodServiceType["BB"] = "B_B";
    FoodServiceType["BarTradizionale"] = "BAR_TRADIZIONALE";
    FoodServiceType["Camping"] = "CAMPING";
    FoodServiceType["Catering"] = "CATERING";
    FoodServiceType["CinemaMultisala"] = "CINEMA_MULTISALA";
    FoodServiceType["Discoteca"] = "DISCOTECA";
    FoodServiceType["Enoteche"] = "ENOTECHE";
    FoodServiceType["Farmacia"] = "FARMACIA";
    FoodServiceType["FastFood"] = "FAST_FOOD";
    FoodServiceType["FoodTruck"] = "FOOD_TRUCK";
    FoodServiceType["Franchiser"] = "FRANCHISER";
    FoodServiceType["Gelateria"] = "GELATERIA";
    FoodServiceType["Hotel"] = "HOTEL";
    FoodServiceType["ImpiantiSportivi"] = "IMPIANTI_SPORTIVI";
    FoodServiceType["IstituzioneCulturale"] = "ISTITUZIONE_CULTURALE";
    FoodServiceType["Latteria"] = "LATTERIA";
    FoodServiceType["Libreria"] = "LIBRERIA";
    FoodServiceType["LocalePolifunz"] = "LOCALE_POLIFUNZ";
    FoodServiceType["Macelleria"] = "MACELLERIA";
    FoodServiceType["Mense"] = "MENSE";
    FoodServiceType["OstelliHotel_2Stelle"] = "OSTELLI_HOTEL_2_STELLE";
    FoodServiceType["Panetteria"] = "PANETTERIA";
    FoodServiceType["ParchiDiDivertimento"] = "PARCHI_DI_DIVERTIMENTO";
    FoodServiceType["Pasticceria"] = "PASTICCERIA";
    FoodServiceType["Pescheria"] = "PESCHERIA";
    FoodServiceType["Polleria"] = "POLLERIA";
    FoodServiceType["PubBirreria"] = "PUB_BIRRERIA";
    FoodServiceType["ResortVillaggioTuristico"] = "RESORT_VILLAGGIO_TURISTICO";
    FoodServiceType["RifugiDiMontagna"] = "RIFUGI_DI_MONTAGNA";
    FoodServiceType["RistPizzeria"] = "RIST_PIZZERIA";
    FoodServiceType["RistEtnico"] = "RIST_ETNICO";
    FoodServiceType["RistPremium"] = "RIST_PREMIUM";
    FoodServiceType["RistorazioneCollettiva"] = "RISTORAZIONE_COLLETTIVA";
    FoodServiceType["RistorazioneCommerciale"] = "RISTORAZIONE_COMMERCIALE";
    FoodServiceType["RistorazioneSuMezzi"] = "RISTORAZIONE_SU_MEZZI";
    FoodServiceType["SaleScommesse"] = "SALE_SCOMMESSE";
    FoodServiceType["Salumeria"] = "SALUMERIA";
    FoodServiceType["StabilimentoBalneare"] = "STABILIMENTO_BALNEARE";
    FoodServiceType["StazioneDiServizio"] = "STAZIONE_DI_SERVIZIO";
    FoodServiceType["Tabaccheria"] = "TABACCHERIA";
    FoodServiceType["TeatroSalaDaConcerto"] = "TEATRO_SALA_DA_CONCERTO";
    FoodServiceType["Torrefazione"] = "TORREFAZIONE";
    FoodServiceType["TrattoriaOsteria"] = "TRATTORIA_OSTERIA";
})(FoodServiceType || (exports.FoodServiceType = FoodServiceType = {}));
/** FrequentSearch's possible collections */
var FrequentSearchCollection;
(function (FrequentSearchCollection) {
    FrequentSearchCollection["Good"] = "GOOD";
    FrequentSearchCollection["Company"] = "COMPANY";
    FrequentSearchCollection["GeoIndication"] = "GEO_INDICATION";
    FrequentSearchCollection["News"] = "NEWS";
})(FrequentSearchCollection || (exports.FrequentSearchCollection = FrequentSearchCollection = {}));
/** FrequentSearch's possible statues */
var FrequentSearchStatus;
(function (FrequentSearchStatus) {
    FrequentSearchStatus["Draft"] = "DRAFT";
    FrequentSearchStatus["Published"] = "PUBLISHED";
    FrequentSearchStatus["Highlighted"] = "HIGHLIGHTED";
    FrequentSearchStatus["Deleted"] = "DELETED";
})(FrequentSearchStatus || (exports.FrequentSearchStatus = FrequentSearchStatus = {}));
/** If FrequentSearch is system-defined this is the type */
var FrequentSearchSystemType;
(function (FrequentSearchSystemType) {
    FrequentSearchSystemType["Favorites"] = "FAVORITES";
})(FrequentSearchSystemType || (exports.FrequentSearchSystemType = FrequentSearchSystemType = {}));
var GeoIndicationOrderBy;
(function (GeoIndicationOrderBy) {
    GeoIndicationOrderBy["Name"] = "name";
    GeoIndicationOrderBy["StateProvince"] = "StateProvince";
    GeoIndicationOrderBy["EuIndication"] = "euIndication";
    GeoIndicationOrderBy["ItalianIndication"] = "italianIndication";
    GeoIndicationOrderBy["Status"] = "status";
})(GeoIndicationOrderBy || (exports.GeoIndicationOrderBy = GeoIndicationOrderBy = {}));
var GoodOrderBy;
(function (GoodOrderBy) {
    GoodOrderBy["Name"] = "name";
    GoodOrderBy["NameIta"] = "nameIta";
})(GoodOrderBy || (exports.GoodOrderBy = GoodOrderBy = {}));
var GoodUnit;
(function (GoodUnit) {
    GoodUnit["Grams"] = "GRAMS";
    GoodUnit["Milliliter"] = "MILLILITER";
    GoodUnit["Milligrams"] = "MILLIGRAMS";
})(GoodUnit || (exports.GoodUnit = GoodUnit = {}));
/** // TODO */
var GridSize;
(function (GridSize) {
    GridSize["Col_1"] = "COL_1";
    GridSize["Col_2"] = "COL_2";
    GridSize["Col_3"] = "COL_3";
})(GridSize || (exports.GridSize = GridSize = {}));
/** Possible Good hightlight reasons */
var HighlightReasons;
(function (HighlightReasons) {
    HighlightReasons["NewProduct"] = "NEW_PRODUCT";
    HighlightReasons["RenovatedRecipe"] = "RENOVATED_RECIPE";
    HighlightReasons["RenovatedPackaging"] = "RENOVATED_PACKAGING";
    HighlightReasons["SpecialEdition"] = "SPECIAL_EDITION";
    HighlightReasons["NewSizes"] = "NEW_SIZES";
})(HighlightReasons || (exports.HighlightReasons = HighlightReasons = {}));
/** SF picklist */
var Indirizzo__C_Tipo__C_Enum;
(function (Indirizzo__C_Tipo__C_Enum) {
    /** Sede legale */
    Indirizzo__C_Tipo__C_Enum["SedeLegale"] = "SEDE_LEGALE";
    /** Sede operativa */
    Indirizzo__C_Tipo__C_Enum["SedeOperativa"] = "SEDE_OPERATIVA";
    /** Spedizioni */
    Indirizzo__C_Tipo__C_Enum["Spedizioni"] = "SPEDIZIONI";
    /** Filiale */
    Indirizzo__C_Tipo__C_Enum["Filiale"] = "FILIALE";
    /** Privato */
    Indirizzo__C_Tipo__C_Enum["Privato"] = "PRIVATO";
    /** Stabilimento di Produzione */
    Indirizzo__C_Tipo__C_Enum["StabilimentoDiProduzione"] = "STABILIMENTO_DI_PRODUZIONE";
    /** Dipartimento Logistico */
    Indirizzo__C_Tipo__C_Enum["DipartimentoLogistico"] = "DIPARTIMENTO_LOGISTICO";
})(Indirizzo__C_Tipo__C_Enum || (exports.Indirizzo__C_Tipo__C_Enum = Indirizzo__C_Tipo__C_Enum = {}));
/** Client-side code load proper form based on this value */
var InputTemplate;
(function (InputTemplate) {
    InputTemplate["NewsletterGeneric"] = "NEWSLETTER_GENERIC";
    InputTemplate["DemGeneric"] = "DEM_GENERIC";
})(InputTemplate || (exports.InputTemplate = InputTemplate = {}));
/** User possible internal Capabilities */
var InternalCapability;
(function (InternalCapability) {
    InternalCapability["UsersBase"] = "USERS_BASE";
    InternalCapability["UsersExtra"] = "USERS_EXTRA";
    InternalCapability["MarketingBase"] = "MARKETING_BASE";
    InternalCapability["MarketingExtra"] = "MARKETING_EXTRA";
    InternalCapability["EditorialBase"] = "EDITORIAL_BASE";
    InternalCapability["EditorialExtra"] = "EDITORIAL_EXTRA";
    InternalCapability["DirectoryBase"] = "DIRECTORY_BASE";
    InternalCapability["DirectoryExtra"] = "DIRECTORY_EXTRA";
    InternalCapability["AdminBase"] = "ADMIN_BASE";
    InternalCapability["AdminExtra"] = "ADMIN_EXTRA";
})(InternalCapability || (exports.InternalCapability = InternalCapability = {}));
/** Italian Indications */
var ItalianIndication;
(function (ItalianIndication) {
    ItalianIndication["Docg"] = "DOCG";
    ItalianIndication["Doc"] = "DOC";
    ItalianIndication["Igt"] = "IGT";
    ItalianIndication["BevandaSpiritosaIg"] = "BEVANDA_SPIRITOSA_IG";
    ItalianIndication["Pat"] = "PAT";
    ItalianIndication["PresidioSlowFood"] = "PRESIDIO_SLOW_FOOD";
    ItalianIndication["ArcaSlowFood"] = "ARCA_SLOW_FOOD";
})(ItalianIndication || (exports.ItalianIndication = ItalianIndication = {}));
var MagazineOrderBy;
(function (MagazineOrderBy) {
    MagazineOrderBy["PublicationDate"] = "publicationDate";
    MagazineOrderBy["IssueNumber"] = "issueNumber";
})(MagazineOrderBy || (exports.MagazineOrderBy = MagazineOrderBy = {}));
var MediaOrderBy;
(function (MediaOrderBy) {
    MediaOrderBy["Caption"] = "caption";
    MediaOrderBy["Timestamp"] = "timestamp";
})(MediaOrderBy || (exports.MediaOrderBy = MediaOrderBy = {}));
/** Supported Media types */
var MediaType;
(function (MediaType) {
    MediaType["Logo"] = "LOGO";
    MediaType["GoodImage"] = "GOOD_IMAGE";
    MediaType["Icon"] = "ICON";
    MediaType["PdfWeb"] = "PDF_WEB";
    MediaType["PdfGeneric"] = "PDF_GENERIC";
    MediaType["BannerFull"] = "BANNER_FULL";
    MediaType["BannerHalf"] = "BANNER_HALF";
    MediaType["BannerLeaderboard"] = "BANNER_LEADERBOARD";
    MediaType["BannerPopup"] = "BANNER_POPUP";
    MediaType["News"] = "NEWS";
    MediaType["MagazineCover"] = "MAGAZINE_COVER";
    MediaType["LogoPrint"] = "LOGO_PRINT";
    MediaType["GoodPrintImage"] = "GOOD_PRINT_IMAGE";
    MediaType["GalleryGeneric"] = "GALLERY_GENERIC";
    MediaType["MailImage"] = "MAIL_IMAGE";
})(MediaType || (exports.MediaType = MediaType = {}));
/** // TODO */
var NewsletterAcceptedFlag;
(function (NewsletterAcceptedFlag) {
    NewsletterAcceptedFlag["General"] = "GENERAL";
})(NewsletterAcceptedFlag || (exports.NewsletterAcceptedFlag = NewsletterAcceptedFlag = {}));
/** News's possible source */
var NewsSource;
(function (NewsSource) {
    NewsSource["Hub"] = "HUB";
    NewsSource["WpIfn"] = "WP_IFN";
    NewsSource["WpFoodweb"] = "WP_FOODWEB";
    NewsSource["WpFoodserviceweb"] = "WP_FOODSERVICEWEB";
    NewsSource["PaperIfn"] = "PAPER_IFN";
})(NewsSource || (exports.NewsSource = NewsSource = {}));
/** News's possible statues */
var NewsStatus;
(function (NewsStatus) {
    NewsStatus["Stub"] = "STUB";
    NewsStatus["Draft"] = "DRAFT";
    NewsStatus["WaitingPublication"] = "WAITING_PUBLICATION";
    NewsStatus["Published"] = "PUBLISHED";
    NewsStatus["Hidden"] = "HIDDEN";
    NewsStatus["Deleted"] = "DELETED";
})(NewsStatus || (exports.NewsStatus = NewsStatus = {}));
var ObjectHistoryAction;
(function (ObjectHistoryAction) {
    ObjectHistoryAction["Create"] = "CREATE";
    ObjectHistoryAction["Patch"] = "PATCH";
    ObjectHistoryAction["SetStatus"] = "SET_STATUS";
    ObjectHistoryAction["Delete"] = "DELETE";
    ObjectHistoryAction["Subcreate"] = "SUBCREATE";
    ObjectHistoryAction["Merge"] = "MERGE";
})(ObjectHistoryAction || (exports.ObjectHistoryAction = ObjectHistoryAction = {}));
var ObjectHistoryCollection;
(function (ObjectHistoryCollection) {
    ObjectHistoryCollection["Abbonamento"] = "Abbonamento";
    ObjectHistoryCollection["AbbonamentoPeriodo"] = "AbbonamentoPeriodo";
    ObjectHistoryCollection["AnswerSet"] = "AnswerSet";
    ObjectHistoryCollection["AtecoCode"] = "AtecoCode";
    ObjectHistoryCollection["Award"] = "Award";
    ObjectHistoryCollection["AwardCategory"] = "AwardCategory";
    ObjectHistoryCollection["AwardInvitedCompany"] = "AwardInvitedCompany";
    ObjectHistoryCollection["AwardInvitedUser"] = "AwardInvitedUser";
    ObjectHistoryCollection["AwardResult"] = "AwardResult";
    ObjectHistoryCollection["Banner"] = "Banner";
    ObjectHistoryCollection["BannerView"] = "BannerView";
    ObjectHistoryCollection["Branch"] = "Branch";
    ObjectHistoryCollection["Brand"] = "Brand";
    ObjectHistoryCollection["CampaignMember"] = "CampaignMember";
    ObjectHistoryCollection["Candidacy"] = "Candidacy";
    ObjectHistoryCollection["CandidacyRating"] = "CandidacyRating";
    ObjectHistoryCollection["Company"] = "Company";
    ObjectHistoryCollection["CompanyBadge"] = "CompanyBadge";
    ObjectHistoryCollection["CompanyCertification"] = "CompanyCertification";
    ObjectHistoryCollection["CompanyGroup"] = "CompanyGroup";
    ObjectHistoryCollection["CompanyLevel"] = "CompanyLevel";
    ObjectHistoryCollection["CompanyYear"] = "CompanyYear";
    ObjectHistoryCollection["Contact"] = "Contact";
    ObjectHistoryCollection["Country"] = "Country";
    ObjectHistoryCollection["Coupon"] = "Coupon";
    ObjectHistoryCollection["DistributionChannel"] = "DistributionChannel";
    ObjectHistoryCollection["EditorialSection"] = "EditorialSection";
    ObjectHistoryCollection["EditorialTag"] = "EditorialTag";
    ObjectHistoryCollection["EmailDomain"] = "EmailDomain";
    ObjectHistoryCollection["EuCategory"] = "EuCategory";
    ObjectHistoryCollection["Fair"] = "Fair";
    ObjectHistoryCollection["FairParticipation"] = "FairParticipation";
    ObjectHistoryCollection["FairVisit"] = "FairVisit";
    ObjectHistoryCollection["FairVisitParticipation"] = "FairVisitParticipation";
    ObjectHistoryCollection["FoodService"] = "FoodService";
    ObjectHistoryCollection["FrequentSearch"] = "FrequentSearch";
    ObjectHistoryCollection["GeoIndication"] = "GeoIndication";
    ObjectHistoryCollection["Good"] = "Good";
    ObjectHistoryCollection["GoodClass"] = "GoodClass";
    ObjectHistoryCollection["GoodFeatureCertification"] = "GoodFeatureCertification";
    ObjectHistoryCollection["GoodFormat"] = "GoodFormat";
    ObjectHistoryCollection["HighlightedGood"] = "HighlightedGood";
    ObjectHistoryCollection["HtmlTemplate"] = "HtmlTemplate";
    ObjectHistoryCollection["Indirizzo"] = "Indirizzo";
    ObjectHistoryCollection["Magazine"] = "Magazine";
    ObjectHistoryCollection["MagazineCollection"] = "MagazineCollection";
    ObjectHistoryCollection["MagazineContent"] = "MagazineContent";
    ObjectHistoryCollection["ManagedByUser"] = "ManagedByUser";
    ObjectHistoryCollection["Media"] = "Media";
    ObjectHistoryCollection["News"] = "News";
    ObjectHistoryCollection["NewsCitation"] = "NewsCitation";
    ObjectHistoryCollection["NewsFormat"] = "NewsFormat";
    ObjectHistoryCollection["Newsletter"] = "Newsletter";
    ObjectHistoryCollection["NewsletterIssue"] = "NewsletterIssue";
    ObjectHistoryCollection["NewsletterIssueHasNews"] = "NewsletterIssueHasNews";
    ObjectHistoryCollection["ObjectHistory"] = "ObjectHistory";
    ObjectHistoryCollection["Permalink"] = "Permalink";
    ObjectHistoryCollection["PiList"] = "PiList";
    ObjectHistoryCollection["PricebookEntry"] = "PricebookEntry";
    ObjectHistoryCollection["Prospect"] = "Prospect";
    ObjectHistoryCollection["QuestionSet"] = "QuestionSet";
    ObjectHistoryCollection["Quote"] = "Quote";
    ObjectHistoryCollection["QuoteLineItem"] = "QuoteLineItem";
    ObjectHistoryCollection["Retailer"] = "Retailer";
    ObjectHistoryCollection["SampleRequest"] = "SampleRequest";
    ObjectHistoryCollection["Service"] = "Service";
    ObjectHistoryCollection["StateProvince"] = "StateProvince";
    ObjectHistoryCollection["Team"] = "Team";
    ObjectHistoryCollection["ToS"] = "ToS";
    ObjectHistoryCollection["Typeform"] = "Typeform";
    ObjectHistoryCollection["User"] = "User";
    ObjectHistoryCollection["UserAchievement"] = "UserAchievement";
    ObjectHistoryCollection["UserNote"] = "UserNote";
    ObjectHistoryCollection["UserObjectSubscription"] = "UserObjectSubscription";
    ObjectHistoryCollection["Widget"] = "Widget";
})(ObjectHistoryCollection || (exports.ObjectHistoryCollection = ObjectHistoryCollection = {}));
/** Preservation types */
var Preservation;
(function (Preservation) {
    Preservation["Perishable"] = "PERISHABLE";
    Preservation["Frozen"] = "FROZEN";
    Preservation["ShelfStable"] = "SHELF_STABLE";
})(Preservation || (exports.Preservation = Preservation = {}));
var PricebookEntryOrderBy;
(function (PricebookEntryOrderBy) {
    PricebookEntryOrderBy["Name"] = "Name";
    PricebookEntryOrderBy["UnitPrice"] = "UnitPrice";
    PricebookEntryOrderBy["Product2Brand"] = "Product2Brand";
    PricebookEntryOrderBy["Product2BrandArea"] = "Product2Brand_Area";
    PricebookEntryOrderBy["Product2DataDiScadenza"] = "Product2Data_di_Scadenza";
    PricebookEntryOrderBy["Product2DataInizioCompetenza"] = "Product2Data_Inizio_Competenza";
    PricebookEntryOrderBy["Product2DataFineCompetenza"] = "Product2Data_Fine_Competenza";
})(PricebookEntryOrderBy || (exports.PricebookEntryOrderBy = PricebookEntryOrderBy = {}));
var PricePositioning;
(function (PricePositioning) {
    PricePositioning["Discount"] = "DISCOUNT";
    PricePositioning["Mainstream"] = "MAINSTREAM";
    PricePositioning["Premium"] = "PREMIUM";
    PricePositioning["Luxury"] = "LUXURY";
})(PricePositioning || (exports.PricePositioning = PricePositioning = {}));
/** SF picklist */
var Product2_Brand__C_EnumFiltered;
(function (Product2_Brand__C_EnumFiltered) {
    /** FOOD */
    Product2_Brand__C_EnumFiltered["Food"] = "FOOD";
    /** FOODSERVICE */
    Product2_Brand__C_EnumFiltered["Foodservice"] = "FOODSERVICE";
    /** DOLCESALATO */
    Product2_Brand__C_EnumFiltered["Dolcesalato"] = "DOLCESALATO";
    /** ITALIANFOOD.NET */
    Product2_Brand__C_EnumFiltered["ItalianfoodNet"] = "ITALIANFOOD_NET";
    /** FIOR FIORE IN CUCINA */
    Product2_Brand__C_EnumFiltered["FiorFioreInCucina"] = "FIOR_FIORE_IN_CUCINA";
    /** PROGETTI */
    Product2_Brand__C_EnumFiltered["Progetti"] = "PROGETTI";
    /** FOOD LABS */
    Product2_Brand__C_EnumFiltered["FoodLabs"] = "FOOD_LABS";
    /** P&B */
    Product2_Brand__C_EnumFiltered["PB"] = "P_B";
    /** BAR BUSINESS */
    Product2_Brand__C_EnumFiltered["BarBusiness"] = "BAR_BUSINESS";
    /** FOOD EDITORE */
    Product2_Brand__C_EnumFiltered["FoodEditore"] = "FOOD_EDITORE";
})(Product2_Brand__C_EnumFiltered || (exports.Product2_Brand__C_EnumFiltered = Product2_Brand__C_EnumFiltered = {}));
/** SF picklist */
var Product2_Brand_Area__C_Enum;
(function (Product2_Brand_Area__C_Enum) {
    /** Rivista */
    Product2_Brand_Area__C_Enum["Rivista"] = "RIVISTA";
    /** Digitale */
    Product2_Brand_Area__C_Enum["Digitale"] = "DIGITALE";
    /** Digitale ITA */
    Product2_Brand_Area__C_Enum["DigitaleIta"] = "DIGITALE_ITA";
    /** Digitale INT */
    Product2_Brand_Area__C_Enum["DigitaleInt"] = "DIGITALE_INT";
    /** Abbonamenti */
    Product2_Brand_Area__C_Enum["Abbonamenti"] = "ABBONAMENTI";
    /** Eventi */
    Product2_Brand_Area__C_Enum["Eventi"] = "EVENTI";
    /** Content */
    Product2_Brand_Area__C_Enum["Content"] = "CONTENT";
    /** Promo */
    Product2_Brand_Area__C_Enum["Promo"] = "PROMO";
    /** Strategia e Progetti Integrati */
    Product2_Brand_Area__C_Enum["StrategiaEProgettiIntegrati"] = "STRATEGIA_E_PROGETTI_INTEGRATI";
    /** Distribuzione Con Reso */
    Product2_Brand_Area__C_Enum["DistribuzioneConReso"] = "DISTRIBUZIONE_CON_RESO";
    /** Distribuzione Senza Reso */
    Product2_Brand_Area__C_Enum["DistribuzioneSenzaReso"] = "DISTRIBUZIONE_SENZA_RESO";
    /** Estero */
    Product2_Brand_Area__C_Enum["Estero"] = "ESTERO";
    /** Servizi Editoriali */
    Product2_Brand_Area__C_Enum["ServiziEditoriali"] = "SERVIZI_EDITORIALI";
    /** Produzione Editoriale Multicanale */
    Product2_Brand_Area__C_Enum["ProduzioneEditorialeMulticanale"] = "PRODUZIONE_EDITORIALE_MULTICANALE";
})(Product2_Brand_Area__C_Enum || (exports.Product2_Brand_Area__C_Enum = Product2_Brand_Area__C_Enum = {}));
/** SF picklist */
var Product2_Famiglia__C_Enum;
(function (Product2_Famiglia__C_Enum) {
    /** Food */
    Product2_Famiglia__C_Enum["Food"] = "FOOD";
    /** Out Of Home */
    Product2_Famiglia__C_Enum["OutOfHome"] = "OUT_OF_HOME";
    /** Content Marketing and Promo */
    Product2_Famiglia__C_Enum["ContentMarketingAndPromo"] = "CONTENT_MARKETING_AND_PROMO";
    /** Editoria */
    Product2_Famiglia__C_Enum["Editoria"] = "EDITORIA";
    /** Italianfood.net */
    Product2_Famiglia__C_Enum["ItalianfoodNet"] = "ITALIANFOOD_NET";
})(Product2_Famiglia__C_Enum || (exports.Product2_Famiglia__C_Enum = Product2_Famiglia__C_Enum = {}));
/** SF picklist */
var Product2_Tipologia__C_Enum;
(function (Product2_Tipologia__C_Enum) {
    /** Periodico */
    Product2_Tipologia__C_Enum["Periodico"] = "PERIODICO";
    /** Digitale */
    Product2_Tipologia__C_Enum["Digitale"] = "DIGITALE";
    /** Speciale */
    Product2_Tipologia__C_Enum["Speciale"] = "SPECIALE";
    /** Food Summit */
    Product2_Tipologia__C_Enum["FoodSummit"] = "FOOD_SUMMIT";
    /** Premiato Prodotto Food */
    Product2_Tipologia__C_Enum["PremiatoProdottoFood"] = "PREMIATO_PRODOTTO_FOOD";
    /** Altri Eventi */
    Product2_Tipologia__C_Enum["AltriEventi"] = "ALTRI_EVENTI";
    /** Foto - Video */
    Product2_Tipologia__C_Enum["FotoVideo"] = "FOTO_VIDEO";
    /** Pubblicazioni */
    Product2_Tipologia__C_Enum["Pubblicazioni"] = "PUBBLICAZIONI";
    /** Post */
    Product2_Tipologia__C_Enum["Post"] = "POST";
    /** Concorso a premi */
    Product2_Tipologia__C_Enum["ConcorsoAPremi"] = "CONCORSO_A_PREMI";
    /** Materiale POP */
    Product2_Tipologia__C_Enum["MaterialePop"] = "MATERIALE_POP";
    /** In Store Promotion */
    Product2_Tipologia__C_Enum["InStorePromotion"] = "IN_STORE_PROMOTION";
    /** Gadget */
    Product2_Tipologia__C_Enum["Gadget"] = "GADGET";
    /** Editoriale */
    Product2_Tipologia__C_Enum["Editoriale"] = "EDITORIALE";
    /** Raccolta Pubblicitaria */
    Product2_Tipologia__C_Enum["RaccoltaPubblicitaria"] = "RACCOLTA_PUBBLICITARIA";
    /** Progettuale */
    Product2_Tipologia__C_Enum["Progettuale"] = "PROGETTUALE";
    /** Riviste */
    Product2_Tipologia__C_Enum["Riviste"] = "RIVISTE";
    /** Showcase */
    Product2_Tipologia__C_Enum["Showcase"] = "SHOWCASE";
    /** Canone */
    Product2_Tipologia__C_Enum["Canone"] = "CANONE";
    /** Servizio Spot */
    Product2_Tipologia__C_Enum["ServizioSpot"] = "SERVIZIO_SPOT";
    /** Fee */
    Product2_Tipologia__C_Enum["Fee"] = "FEE";
})(Product2_Tipologia__C_Enum || (exports.Product2_Tipologia__C_Enum = Product2_Tipologia__C_Enum = {}));
/** Possible requests */
var QuestionSetRequest;
(function (QuestionSetRequest) {
    QuestionSetRequest["Catalog"] = "CATALOG";
    QuestionSetRequest["Price"] = "PRICE";
    QuestionSetRequest["Resellers"] = "RESELLERS";
    QuestionSetRequest["Contact"] = "CONTACT";
})(QuestionSetRequest || (exports.QuestionSetRequest = QuestionSetRequest = {}));
/** SF picklist */
var Quote_BillingCountryCode_Enum;
(function (Quote_BillingCountryCode_Enum) {
    /** Afghanistan */
    Quote_BillingCountryCode_Enum["Af"] = "AF";
    /** Aland Islands */
    Quote_BillingCountryCode_Enum["Ax"] = "AX";
    /** Albania */
    Quote_BillingCountryCode_Enum["Al"] = "AL";
    /** Algeria */
    Quote_BillingCountryCode_Enum["Dz"] = "DZ";
    /** Andorra */
    Quote_BillingCountryCode_Enum["Ad"] = "AD";
    /** Angola */
    Quote_BillingCountryCode_Enum["Ao"] = "AO";
    /** Anguilla */
    Quote_BillingCountryCode_Enum["Ai"] = "AI";
    /** Antarctica */
    Quote_BillingCountryCode_Enum["Aq"] = "AQ";
    /** Antigua and Barbuda */
    Quote_BillingCountryCode_Enum["Ag"] = "AG";
    /** Argentina */
    Quote_BillingCountryCode_Enum["Ar"] = "AR";
    /** Armenia */
    Quote_BillingCountryCode_Enum["Am"] = "AM";
    /** Aruba */
    Quote_BillingCountryCode_Enum["Aw"] = "AW";
    /** Australia */
    Quote_BillingCountryCode_Enum["Au"] = "AU";
    /** Austria */
    Quote_BillingCountryCode_Enum["At"] = "AT";
    /** Azerbaijan */
    Quote_BillingCountryCode_Enum["Az"] = "AZ";
    /** Bahamas */
    Quote_BillingCountryCode_Enum["Bs"] = "BS";
    /** Bahrain */
    Quote_BillingCountryCode_Enum["Bh"] = "BH";
    /** Bangladesh */
    Quote_BillingCountryCode_Enum["Bd"] = "BD";
    /** Barbados */
    Quote_BillingCountryCode_Enum["Bb"] = "BB";
    /** Belarus */
    Quote_BillingCountryCode_Enum["By"] = "BY";
    /** Belgium */
    Quote_BillingCountryCode_Enum["Be"] = "BE";
    /** Belize */
    Quote_BillingCountryCode_Enum["Bz"] = "BZ";
    /** Benin */
    Quote_BillingCountryCode_Enum["Bj"] = "BJ";
    /** Bermuda */
    Quote_BillingCountryCode_Enum["Bm"] = "BM";
    /** Bhutan */
    Quote_BillingCountryCode_Enum["Bt"] = "BT";
    /** Bolivia, Plurinational State of */
    Quote_BillingCountryCode_Enum["Bo"] = "BO";
    /** Bonaire, Sint Eustatius and Saba */
    Quote_BillingCountryCode_Enum["Bq"] = "BQ";
    /** Bosnia Erzegovina */
    Quote_BillingCountryCode_Enum["Ba"] = "BA";
    /** Botswana */
    Quote_BillingCountryCode_Enum["Bw"] = "BW";
    /** Bouvet Island */
    Quote_BillingCountryCode_Enum["Bv"] = "BV";
    /** Brazil */
    Quote_BillingCountryCode_Enum["Br"] = "BR";
    /** British Indian Ocean Territory */
    Quote_BillingCountryCode_Enum["Io"] = "IO";
    /** Brunei */
    Quote_BillingCountryCode_Enum["Bn"] = "BN";
    /** Bulgaria */
    Quote_BillingCountryCode_Enum["Bg"] = "BG";
    /** Burkina Faso */
    Quote_BillingCountryCode_Enum["Bf"] = "BF";
    /** Burundi */
    Quote_BillingCountryCode_Enum["Bi"] = "BI";
    /** Cambodia */
    Quote_BillingCountryCode_Enum["Kh"] = "KH";
    /** Cameroon */
    Quote_BillingCountryCode_Enum["Cm"] = "CM";
    /** Canada */
    Quote_BillingCountryCode_Enum["Ca"] = "CA";
    /** Cape Verde */
    Quote_BillingCountryCode_Enum["Cv"] = "CV";
    /** Cayman Islands */
    Quote_BillingCountryCode_Enum["Ky"] = "KY";
    /** Central African Republic */
    Quote_BillingCountryCode_Enum["Cf"] = "CF";
    /** Chad */
    Quote_BillingCountryCode_Enum["Td"] = "TD";
    /** Chile */
    Quote_BillingCountryCode_Enum["Cl"] = "CL";
    /** China */
    Quote_BillingCountryCode_Enum["Cn"] = "CN";
    /** Christmas Island */
    Quote_BillingCountryCode_Enum["Cx"] = "CX";
    /** Cocos (Keeling) Islands */
    Quote_BillingCountryCode_Enum["Cc"] = "CC";
    /** Colombia */
    Quote_BillingCountryCode_Enum["Co"] = "CO";
    /** Comoros */
    Quote_BillingCountryCode_Enum["Km"] = "KM";
    /** Congo */
    Quote_BillingCountryCode_Enum["Cg"] = "CG";
    /** Congo, the Democratic Republic of the */
    Quote_BillingCountryCode_Enum["Cd"] = "CD";
    /** Cook Islands */
    Quote_BillingCountryCode_Enum["Ck"] = "CK";
    /** Costa Rica */
    Quote_BillingCountryCode_Enum["Cr"] = "CR";
    /** Cote d'Ivoire */
    Quote_BillingCountryCode_Enum["Ci"] = "CI";
    /** Croatia */
    Quote_BillingCountryCode_Enum["Hr"] = "HR";
    /** Cuba */
    Quote_BillingCountryCode_Enum["Cu"] = "CU";
    /** Curaçao */
    Quote_BillingCountryCode_Enum["Cw"] = "CW";
    /** Cyprus */
    Quote_BillingCountryCode_Enum["Cy"] = "CY";
    /** Czech Republic */
    Quote_BillingCountryCode_Enum["Cz"] = "CZ";
    /** Denmark */
    Quote_BillingCountryCode_Enum["Dk"] = "DK";
    /** Djibouti */
    Quote_BillingCountryCode_Enum["Dj"] = "DJ";
    /** Dominica */
    Quote_BillingCountryCode_Enum["Dm"] = "DM";
    /** Dominican Republic */
    Quote_BillingCountryCode_Enum["Do"] = "DO";
    /** Ecuador */
    Quote_BillingCountryCode_Enum["Ec"] = "EC";
    /** Egypt */
    Quote_BillingCountryCode_Enum["Eg"] = "EG";
    /** El Salvador */
    Quote_BillingCountryCode_Enum["Sv"] = "SV";
    /** Equatorial Guinea */
    Quote_BillingCountryCode_Enum["Gq"] = "GQ";
    /** Eritrea */
    Quote_BillingCountryCode_Enum["Er"] = "ER";
    /** Estonia */
    Quote_BillingCountryCode_Enum["Ee"] = "EE";
    /** Ethiopia */
    Quote_BillingCountryCode_Enum["Et"] = "ET";
    /** Falkland Islands (Malvinas) */
    Quote_BillingCountryCode_Enum["Fk"] = "FK";
    /** Faroe Islands */
    Quote_BillingCountryCode_Enum["Fo"] = "FO";
    /** Fiji */
    Quote_BillingCountryCode_Enum["Fj"] = "FJ";
    /** Finland */
    Quote_BillingCountryCode_Enum["Fi"] = "FI";
    /** France */
    Quote_BillingCountryCode_Enum["Fr"] = "FR";
    /** French Guiana */
    Quote_BillingCountryCode_Enum["Gf"] = "GF";
    /** French Polynesia */
    Quote_BillingCountryCode_Enum["Pf"] = "PF";
    /** French Southern Territories */
    Quote_BillingCountryCode_Enum["Tf"] = "TF";
    /** Gabon */
    Quote_BillingCountryCode_Enum["Ga"] = "GA";
    /** Gambia */
    Quote_BillingCountryCode_Enum["Gm"] = "GM";
    /** Georgia */
    Quote_BillingCountryCode_Enum["Ge"] = "GE";
    /** Germany */
    Quote_BillingCountryCode_Enum["De"] = "DE";
    /** Ghana */
    Quote_BillingCountryCode_Enum["Gh"] = "GH";
    /** Gibraltar */
    Quote_BillingCountryCode_Enum["Gi"] = "GI";
    /** Greece */
    Quote_BillingCountryCode_Enum["Gr"] = "GR";
    /** Greenland */
    Quote_BillingCountryCode_Enum["Gl"] = "GL";
    /** Grenada */
    Quote_BillingCountryCode_Enum["Gd"] = "GD";
    /** Guadeloupe */
    Quote_BillingCountryCode_Enum["Gp"] = "GP";
    /** Guatemala */
    Quote_BillingCountryCode_Enum["Gt"] = "GT";
    /** Guernsey */
    Quote_BillingCountryCode_Enum["Gg"] = "GG";
    /** Guinea */
    Quote_BillingCountryCode_Enum["Gn"] = "GN";
    /** Guinea-Bissau */
    Quote_BillingCountryCode_Enum["Gw"] = "GW";
    /** Guyana */
    Quote_BillingCountryCode_Enum["Gy"] = "GY";
    /** Haiti */
    Quote_BillingCountryCode_Enum["Ht"] = "HT";
    /** Heard Island and McDonald Islands */
    Quote_BillingCountryCode_Enum["Hm"] = "HM";
    /** Holy See (Vatican City State) */
    Quote_BillingCountryCode_Enum["Va"] = "VA";
    /** Honduras */
    Quote_BillingCountryCode_Enum["Hn"] = "HN";
    /** Hungary */
    Quote_BillingCountryCode_Enum["Hu"] = "HU";
    /** Iceland */
    Quote_BillingCountryCode_Enum["Is"] = "IS";
    /** India */
    Quote_BillingCountryCode_Enum["In"] = "IN";
    /** Indonesia */
    Quote_BillingCountryCode_Enum["Id"] = "ID";
    /** Iran */
    Quote_BillingCountryCode_Enum["Ir"] = "IR";
    /** Iraq */
    Quote_BillingCountryCode_Enum["Iq"] = "IQ";
    /** Ireland */
    Quote_BillingCountryCode_Enum["Ie"] = "IE";
    /** Isle of Man */
    Quote_BillingCountryCode_Enum["Im"] = "IM";
    /** Israel */
    Quote_BillingCountryCode_Enum["Il"] = "IL";
    /** Italia */
    Quote_BillingCountryCode_Enum["It"] = "IT";
    /** Jamaica */
    Quote_BillingCountryCode_Enum["Jm"] = "JM";
    /** Japan */
    Quote_BillingCountryCode_Enum["Jp"] = "JP";
    /** Jersey */
    Quote_BillingCountryCode_Enum["Je"] = "JE";
    /** Jordan */
    Quote_BillingCountryCode_Enum["Jo"] = "JO";
    /** Kazakhstan */
    Quote_BillingCountryCode_Enum["Kz"] = "KZ";
    /** Kenya */
    Quote_BillingCountryCode_Enum["Ke"] = "KE";
    /** Kiribati */
    Quote_BillingCountryCode_Enum["Ki"] = "KI";
    /** Korea, Democratic People's Republic of */
    Quote_BillingCountryCode_Enum["Kp"] = "KP";
    /** Kuwait */
    Quote_BillingCountryCode_Enum["Kw"] = "KW";
    /** Kyrgyzstan */
    Quote_BillingCountryCode_Enum["Kg"] = "KG";
    /** Lao People's Democratic Republic */
    Quote_BillingCountryCode_Enum["La"] = "LA";
    /** Latvia */
    Quote_BillingCountryCode_Enum["Lv"] = "LV";
    /** Lebanon */
    Quote_BillingCountryCode_Enum["Lb"] = "LB";
    /** Lesotho */
    Quote_BillingCountryCode_Enum["Ls"] = "LS";
    /** Liberia */
    Quote_BillingCountryCode_Enum["Lr"] = "LR";
    /** Libya */
    Quote_BillingCountryCode_Enum["Ly"] = "LY";
    /** Liechtenstein */
    Quote_BillingCountryCode_Enum["Li"] = "LI";
    /** Lithuania */
    Quote_BillingCountryCode_Enum["Lt"] = "LT";
    /** Luxembourg */
    Quote_BillingCountryCode_Enum["Lu"] = "LU";
    /** Macao */
    Quote_BillingCountryCode_Enum["Mo"] = "MO";
    /** Macedonia */
    Quote_BillingCountryCode_Enum["Mk"] = "MK";
    /** Madagascar */
    Quote_BillingCountryCode_Enum["Mg"] = "MG";
    /** Malawi */
    Quote_BillingCountryCode_Enum["Mw"] = "MW";
    /** Malaysia */
    Quote_BillingCountryCode_Enum["My"] = "MY";
    /** Maldives */
    Quote_BillingCountryCode_Enum["Mv"] = "MV";
    /** Mali */
    Quote_BillingCountryCode_Enum["Ml"] = "ML";
    /** Malta */
    Quote_BillingCountryCode_Enum["Mt"] = "MT";
    /** Martinique */
    Quote_BillingCountryCode_Enum["Mq"] = "MQ";
    /** Mauritania */
    Quote_BillingCountryCode_Enum["Mr"] = "MR";
    /** Mauritius */
    Quote_BillingCountryCode_Enum["Mu"] = "MU";
    /** Mayotte */
    Quote_BillingCountryCode_Enum["Yt"] = "YT";
    /** Mexico */
    Quote_BillingCountryCode_Enum["Mx"] = "MX";
    /** Moldova, Republic of */
    Quote_BillingCountryCode_Enum["Md"] = "MD";
    /** Monaco */
    Quote_BillingCountryCode_Enum["Mc"] = "MC";
    /** Mongolia */
    Quote_BillingCountryCode_Enum["Mn"] = "MN";
    /** Montenegro */
    Quote_BillingCountryCode_Enum["Me"] = "ME";
    /** Montserrat */
    Quote_BillingCountryCode_Enum["Ms"] = "MS";
    /** Morocco */
    Quote_BillingCountryCode_Enum["Ma"] = "MA";
    /** Mozambique */
    Quote_BillingCountryCode_Enum["Mz"] = "MZ";
    /** Myanmar */
    Quote_BillingCountryCode_Enum["Mm"] = "MM";
    /** Namibia */
    Quote_BillingCountryCode_Enum["Na"] = "NA";
    /** Nauru */
    Quote_BillingCountryCode_Enum["Nr"] = "NR";
    /** Nepal */
    Quote_BillingCountryCode_Enum["Np"] = "NP";
    /** Netherlands */
    Quote_BillingCountryCode_Enum["Nl"] = "NL";
    /** New Caledonia */
    Quote_BillingCountryCode_Enum["Nc"] = "NC";
    /** New Zealand */
    Quote_BillingCountryCode_Enum["Nz"] = "NZ";
    /** Nicaragua */
    Quote_BillingCountryCode_Enum["Ni"] = "NI";
    /** Niger */
    Quote_BillingCountryCode_Enum["Ne"] = "NE";
    /** Nigeria */
    Quote_BillingCountryCode_Enum["Ng"] = "NG";
    /** Niue */
    Quote_BillingCountryCode_Enum["Nu"] = "NU";
    /** Norfolk Island */
    Quote_BillingCountryCode_Enum["Nf"] = "NF";
    /** Norway */
    Quote_BillingCountryCode_Enum["No"] = "NO";
    /** Oman */
    Quote_BillingCountryCode_Enum["Om"] = "OM";
    /** Pakistan */
    Quote_BillingCountryCode_Enum["Pk"] = "PK";
    /** Palestine */
    Quote_BillingCountryCode_Enum["Ps"] = "PS";
    /** Panama */
    Quote_BillingCountryCode_Enum["Pa"] = "PA";
    /** Papua New Guinea */
    Quote_BillingCountryCode_Enum["Pg"] = "PG";
    /** Paraguay */
    Quote_BillingCountryCode_Enum["Py"] = "PY";
    /** Peru */
    Quote_BillingCountryCode_Enum["Pe"] = "PE";
    /** Philippines */
    Quote_BillingCountryCode_Enum["Ph"] = "PH";
    /** Pitcairn */
    Quote_BillingCountryCode_Enum["Pn"] = "PN";
    /** Poland */
    Quote_BillingCountryCode_Enum["Pl"] = "PL";
    /** Portugal */
    Quote_BillingCountryCode_Enum["Pt"] = "PT";
    /** Qatar */
    Quote_BillingCountryCode_Enum["Qa"] = "QA";
    /** Reunion */
    Quote_BillingCountryCode_Enum["Re"] = "RE";
    /** Romania */
    Quote_BillingCountryCode_Enum["Ro"] = "RO";
    /** Russian Federation */
    Quote_BillingCountryCode_Enum["Ru"] = "RU";
    /** Rwanda */
    Quote_BillingCountryCode_Enum["Rw"] = "RW";
    /** Saint Barthélemy */
    Quote_BillingCountryCode_Enum["Bl"] = "BL";
    /** Saint Helena, Ascension and Tristan da Cunha */
    Quote_BillingCountryCode_Enum["Sh"] = "SH";
    /** Saint Kitts and Nevis */
    Quote_BillingCountryCode_Enum["Kn"] = "KN";
    /** Saint Lucia */
    Quote_BillingCountryCode_Enum["Lc"] = "LC";
    /** Saint Martin (French part) */
    Quote_BillingCountryCode_Enum["Mf"] = "MF";
    /** Saint Pierre and Miquelon */
    Quote_BillingCountryCode_Enum["Pm"] = "PM";
    /** Saint Vincent and the Grenadines */
    Quote_BillingCountryCode_Enum["Vc"] = "VC";
    /** Samoa */
    Quote_BillingCountryCode_Enum["Ws"] = "WS";
    /** San Marino */
    Quote_BillingCountryCode_Enum["Sm"] = "SM";
    /** Sao Tome and Principe */
    Quote_BillingCountryCode_Enum["St"] = "ST";
    /** Saudi Arabia */
    Quote_BillingCountryCode_Enum["Sa"] = "SA";
    /** Senegal */
    Quote_BillingCountryCode_Enum["Sn"] = "SN";
    /** Serbia */
    Quote_BillingCountryCode_Enum["Rs"] = "RS";
    /** Seychelles */
    Quote_BillingCountryCode_Enum["Sc"] = "SC";
    /** Sierra Leone */
    Quote_BillingCountryCode_Enum["Sl"] = "SL";
    /** Singapore */
    Quote_BillingCountryCode_Enum["Sg"] = "SG";
    /** Sint Maarten (Dutch part) */
    Quote_BillingCountryCode_Enum["Sx"] = "SX";
    /** Slovakia */
    Quote_BillingCountryCode_Enum["Sk"] = "SK";
    /** Slovenia */
    Quote_BillingCountryCode_Enum["Si"] = "SI";
    /** Solomon Islands */
    Quote_BillingCountryCode_Enum["Sb"] = "SB";
    /** Somalia */
    Quote_BillingCountryCode_Enum["So"] = "SO";
    /** South Africa */
    Quote_BillingCountryCode_Enum["Za"] = "ZA";
    /** South Georgia and the South Sandwich Islands */
    Quote_BillingCountryCode_Enum["Gs"] = "GS";
    /** South Korea */
    Quote_BillingCountryCode_Enum["Kr"] = "KR";
    /** South Sudan */
    Quote_BillingCountryCode_Enum["Ss"] = "SS";
    /** Spain */
    Quote_BillingCountryCode_Enum["Es"] = "ES";
    /** Sri Lanka */
    Quote_BillingCountryCode_Enum["Lk"] = "LK";
    /** Sudan */
    Quote_BillingCountryCode_Enum["Sd"] = "SD";
    /** Suriname */
    Quote_BillingCountryCode_Enum["Sr"] = "SR";
    /** Svalbard and Jan Mayen */
    Quote_BillingCountryCode_Enum["Sj"] = "SJ";
    /** Swaziland */
    Quote_BillingCountryCode_Enum["Sz"] = "SZ";
    /** Sweden */
    Quote_BillingCountryCode_Enum["Se"] = "SE";
    /** Switzerland */
    Quote_BillingCountryCode_Enum["Ch"] = "CH";
    /** Syria */
    Quote_BillingCountryCode_Enum["Sy"] = "SY";
    /** Taiwan */
    Quote_BillingCountryCode_Enum["Tw"] = "TW";
    /** Tajikistan */
    Quote_BillingCountryCode_Enum["Tj"] = "TJ";
    /** Tanzania, United Republic of */
    Quote_BillingCountryCode_Enum["Tz"] = "TZ";
    /** Thailand */
    Quote_BillingCountryCode_Enum["Th"] = "TH";
    /** Timor-Leste */
    Quote_BillingCountryCode_Enum["Tl"] = "TL";
    /** Togo */
    Quote_BillingCountryCode_Enum["Tg"] = "TG";
    /** Tokelau */
    Quote_BillingCountryCode_Enum["Tk"] = "TK";
    /** Tonga */
    Quote_BillingCountryCode_Enum["To"] = "TO";
    /** Trinidad and Tobago */
    Quote_BillingCountryCode_Enum["Tt"] = "TT";
    /** Tunisia */
    Quote_BillingCountryCode_Enum["Tn"] = "TN";
    /** Turkey */
    Quote_BillingCountryCode_Enum["Tr"] = "TR";
    /** Turkmenistan */
    Quote_BillingCountryCode_Enum["Tm"] = "TM";
    /** Turks and Caicos Islands */
    Quote_BillingCountryCode_Enum["Tc"] = "TC";
    /** Tuvalu */
    Quote_BillingCountryCode_Enum["Tv"] = "TV";
    /** Uganda */
    Quote_BillingCountryCode_Enum["Ug"] = "UG";
    /** Ukraine */
    Quote_BillingCountryCode_Enum["Ua"] = "UA";
    /** United Arab Emirates */
    Quote_BillingCountryCode_Enum["Ae"] = "AE";
    /** United Kingdom */
    Quote_BillingCountryCode_Enum["Gb"] = "GB";
    /** United States */
    Quote_BillingCountryCode_Enum["Us"] = "US";
    /** Uruguay */
    Quote_BillingCountryCode_Enum["Uy"] = "UY";
    /** Uzbekistan */
    Quote_BillingCountryCode_Enum["Uz"] = "UZ";
    /** Vanuatu */
    Quote_BillingCountryCode_Enum["Vu"] = "VU";
    /** Venezuela */
    Quote_BillingCountryCode_Enum["Ve"] = "VE";
    /** Vietnam */
    Quote_BillingCountryCode_Enum["Vn"] = "VN";
    /** Virgin Islands, British */
    Quote_BillingCountryCode_Enum["Vg"] = "VG";
    /** Wallis and Futuna */
    Quote_BillingCountryCode_Enum["Wf"] = "WF";
    /** Western Sahara */
    Quote_BillingCountryCode_Enum["Eh"] = "EH";
    /** Yemen */
    Quote_BillingCountryCode_Enum["Ye"] = "YE";
    /** Zambia */
    Quote_BillingCountryCode_Enum["Zm"] = "ZM";
    /** Zimbabwe */
    Quote_BillingCountryCode_Enum["Zw"] = "ZW";
})(Quote_BillingCountryCode_Enum || (exports.Quote_BillingCountryCode_Enum = Quote_BillingCountryCode_Enum = {}));
/** SF picklist */
var Quote_Condizioni_Di_Pagamento__C_Enum;
(function (Quote_Condizioni_Di_Pagamento__C_Enum) {
    /** BONIFICO BANCARIO 30 GG DF. FM. */
    Quote_Condizioni_Di_Pagamento__C_Enum["BonificoBancario_30GgDfFm"] = "BONIFICO_BANCARIO_30_GG_DF_FM";
    /** BONIFICO BANCARIO 60 GG DF. FM. */
    Quote_Condizioni_Di_Pagamento__C_Enum["BonificoBancario_60GgDfFm"] = "BONIFICO_BANCARIO_60_GG_DF_FM";
    /** BONIFICO BANCARIO 90 GG DF. FM. */
    Quote_Condizioni_Di_Pagamento__C_Enum["BonificoBancario_90GgDfFm"] = "BONIFICO_BANCARIO_90_GG_DF_FM";
    /** RICEVUTA BANCARIA 30 GG DF.FM. */
    Quote_Condizioni_Di_Pagamento__C_Enum["RicevutaBancaria_30GgDfFm"] = "RICEVUTA_BANCARIA_30_GG_DF_FM";
    /** RICEVUTA BANCARIA 60 GG DF.FM. */
    Quote_Condizioni_Di_Pagamento__C_Enum["RicevutaBancaria_60GgDfFm"] = "RICEVUTA_BANCARIA_60_GG_DF_FM";
    /** RICEVUTA BANCARIA 90 GG DF.FM. */
    Quote_Condizioni_Di_Pagamento__C_Enum["RicevutaBancaria_90GgDfFm"] = "RICEVUTA_BANCARIA_90_GG_DF_FM";
    /** COMPENSAZIONE PARTITE */
    Quote_Condizioni_Di_Pagamento__C_Enum["CompensazionePartite"] = "COMPENSAZIONE_PARTITE";
    /** ASSEGNO BANCARIO */
    Quote_Condizioni_Di_Pagamento__C_Enum["AssegnoBancario"] = "ASSEGNO_BANCARIO";
    /** ADDEBITO CARTA DI CREDITO */
    Quote_Condizioni_Di_Pagamento__C_Enum["AddebitoCartaDiCredito"] = "ADDEBITO_CARTA_DI_CREDITO";
    /** ADDEBITO C/POSTALE */
    Quote_Condizioni_Di_Pagamento__C_Enum["AddebitoCPostale"] = "ADDEBITO_C_POSTALE";
    /** ADDEBITO DENARO CONTANTE */
    Quote_Condizioni_Di_Pagamento__C_Enum["AddebitoDenaroContante"] = "ADDEBITO_DENARO_CONTANTE";
    /** ADDEBITO BONIFICO BANCARIO */
    Quote_Condizioni_Di_Pagamento__C_Enum["AddebitoBonificoBancario"] = "ADDEBITO_BONIFICO_BANCARIO";
    /** BONIFICO BANCARIO */
    Quote_Condizioni_Di_Pagamento__C_Enum["BonificoBancario"] = "BONIFICO_BANCARIO";
    /** DENARO CONTANTE */
    Quote_Condizioni_Di_Pagamento__C_Enum["DenaroContante"] = "DENARO_CONTANTE";
    /** B.B. 50% ALLA CONSEGNA + B.B. 50% 60 GG DATA FATTURA FM */
    Quote_Condizioni_Di_Pagamento__C_Enum["BB_50AllaConsegnaBB_50_60GgDataFatturaFm"] = "B_B_50_ALLA_CONSEGNA_B_B_50_60_GG_DATA_FATTURA_FM";
    /** B.B. 50% ALLA CONSEGNA + B.B. 50% A 30 GG DATA FATTURA */
    Quote_Condizioni_Di_Pagamento__C_Enum["BB_50AllaConsegnaBB_50A_30GgDataFattura"] = "B_B_50_ALLA_CONSEGNA_B_B_50_A_30_GG_DATA_FATTURA";
    /** BONIFICO BANCARIO 120 GG DF.FM. */
    Quote_Condizioni_Di_Pagamento__C_Enum["BonificoBancario_120GgDfFm"] = "BONIFICO_BANCARIO_120_GG_DF_FM";
    /** BONIFICO BANCARIO 150 GG DF.FM. */
    Quote_Condizioni_Di_Pagamento__C_Enum["BonificoBancario_150GgDfFm"] = "BONIFICO_BANCARIO_150_GG_DF_FM";
    /** BONIFICO BANCARIO 180 GG.DF.FM */
    Quote_Condizioni_Di_Pagamento__C_Enum["BonificoBancario_180GgDfFm"] = "BONIFICO_BANCARIO_180_GG_DF_FM";
    /** BONIFICO BANCARIO 120 GG DATA FATTURA */
    Quote_Condizioni_Di_Pagamento__C_Enum["BonificoBancario_120GgDataFattura"] = "BONIFICO_BANCARIO_120_GG_DATA_FATTURA";
    /** BONIFICO BANCARIO 15 GG DATA FATTURA FINE MESE */
    Quote_Condizioni_Di_Pagamento__C_Enum["BonificoBancario_15GgDataFatturaFineMese"] = "BONIFICO_BANCARIO_15_GG_DATA_FATTURA_FINE_MESE";
    /** BONIFICO BANCARIO 30 GG DATA FATTURA */
    Quote_Condizioni_Di_Pagamento__C_Enum["BonificoBancario_30GgDataFattura"] = "BONIFICO_BANCARIO_30_GG_DATA_FATTURA";
    /** BONIFICO BANCARIO 30 GG DF.FM. + 15 MESE SUCCESSIVO */
    Quote_Condizioni_Di_Pagamento__C_Enum["BonificoBancario_30GgDfFm_15MeseSuccessivo"] = "BONIFICO_BANCARIO_30_GG_DF_FM_15_MESE_SUCCESSIVO";
    /** BONIFICO BANCARIO 30/60 GG DF FM */
    Quote_Condizioni_Di_Pagamento__C_Enum["BonificoBancario_30_60GgDfFm"] = "BONIFICO_BANCARIO_30_60_GG_DF_FM";
    /** BONIFICO BANCARIO 60 GG DATA FATTURA */
    Quote_Condizioni_Di_Pagamento__C_Enum["BonificoBancario_60GgDataFattura"] = "BONIFICO_BANCARIO_60_GG_DATA_FATTURA";
    /** BONIFICO BANCARIO 90 GG DATA FATTURA */
    Quote_Condizioni_Di_Pagamento__C_Enum["BonificoBancario_90GgDataFattura"] = "BONIFICO_BANCARIO_90_GG_DATA_FATTURA";
    /** BONIFICO BANCARIO 90/120 GG DF.FM. */
    Quote_Condizioni_Di_Pagamento__C_Enum["BonificoBancario_90_120GgDfFm"] = "BONIFICO_BANCARIO_90_120_GG_DF_FM";
    /** RICEVUTA BANCARIA 120 GG DF.FM. */
    Quote_Condizioni_Di_Pagamento__C_Enum["RicevutaBancaria_120GgDfFm"] = "RICEVUTA_BANCARIA_120_GG_DF_FM";
    /** RICEVUTA BANCARIA 150 GG.DF FM */
    Quote_Condizioni_Di_Pagamento__C_Enum["RicevutaBancaria_150GgDfFm"] = "RICEVUTA_BANCARIA_150_GG_DF_FM";
    /** RICEVUTA BANCARIA 30/60/90 GG DF.FM. */
    Quote_Condizioni_Di_Pagamento__C_Enum["RicevutaBancaria_30_60_90GgDfFm"] = "RICEVUTA_BANCARIA_30_60_90_GG_DF_FM";
    /** RICEVUTA BANCARIA 60/90 GG DF.FM. */
    Quote_Condizioni_Di_Pagamento__C_Enum["RicevutaBancaria_60_90GgDfFm"] = "RICEVUTA_BANCARIA_60_90_GG_DF_FM";
    /** RIMESSA DIRETTA RICEVIMENTO FATTURA */
    Quote_Condizioni_Di_Pagamento__C_Enum["RimessaDirettaRicevimentoFattura"] = "RIMESSA_DIRETTA_RICEVIMENTO_FATTURA";
    /** FATTURE INFRAGRUPPO */
    Quote_Condizioni_Di_Pagamento__C_Enum["FattureInfragruppo"] = "FATTURE_INFRAGRUPPO";
    /** CONFIRMING A 120 GG */
    Quote_Condizioni_Di_Pagamento__C_Enum["ConfirmingA_120Gg"] = "CONFIRMING_A_120_GG";
    /** BB 1/3 A VISTA, 1/3 A 90 A GG DF FM, 1/3 90 A 150 GG DF FM */
    Quote_Condizioni_Di_Pagamento__C_Enum["Bb_1_3AVista_1_3A_90AGgDfFm_1_3_90A_150GgDfFm"] = "BB_1_3_A_VISTA_1_3_A_90_A_GG_DF_FM_1_3_90_A_150_GG_DF_FM";
})(Quote_Condizioni_Di_Pagamento__C_Enum || (exports.Quote_Condizioni_Di_Pagamento__C_Enum = Quote_Condizioni_Di_Pagamento__C_Enum = {}));
/** SF picklist */
var Quote_Status_Enum;
(function (Quote_Status_Enum) {
    /** Da approvare */
    Quote_Status_Enum["DaApprovare"] = "DA_APPROVARE";
    /** Rifiutato */
    Quote_Status_Enum["Rifiutato"] = "RIFIUTATO";
    /** Approvato */
    Quote_Status_Enum["Approvato"] = "APPROVATO";
})(Quote_Status_Enum || (exports.Quote_Status_Enum = Quote_Status_Enum = {}));
/** Se chi compra lo fa da privato, libero professionista o azienda */
var QuoteAccountType;
(function (QuoteAccountType) {
    QuoteAccountType["Private"] = "PRIVATE";
    QuoteAccountType["Freelance"] = "FREELANCE";
    QuoteAccountType["Company"] = "COMPANY";
})(QuoteAccountType || (exports.QuoteAccountType = QuoteAccountType = {}));
var RetailerOrderBy;
(function (RetailerOrderBy) {
    RetailerOrderBy["Name"] = "name";
    RetailerOrderBy["Type"] = "type";
})(RetailerOrderBy || (exports.RetailerOrderBy = RetailerOrderBy = {}));
/** Retailer possible types */
var RetailerType;
(function (RetailerType) {
    RetailerType["FoodServiceAltriGrossisti"] = "FOOD_SERVICE_ALTRI_GROSSISTI";
    RetailerType["FoodServiceGrossistaBeverage"] = "FOOD_SERVICE_GROSSISTA_BEVERAGE";
    RetailerType["FoodServiceGrossistaCaffET"] = "FOOD_SERVICE_GROSSISTA_CAFF_E_T";
    RetailerType["FoodServiceGrossistaCarniESalumi"] = "FOOD_SERVICE_GROSSISTA_CARNI_E_SALUMI";
    RetailerType["FoodServiceGrossistaDolciario"] = "FOOD_SERVICE_GROSSISTA_DOLCIARIO";
    RetailerType["FoodServiceGrossistaGourmet"] = "FOOD_SERVICE_GROSSISTA_GOURMET";
    RetailerType["FoodServiceGrossistaLatteEDerivati"] = "FOOD_SERVICE_GROSSISTA_LATTE_E_DERIVATI";
    RetailerType["FoodServiceGrossistaOli"] = "FOOD_SERVICE_GROSSISTA_OLI";
    RetailerType["FoodServiceGrossistaOrtofrutta"] = "FOOD_SERVICE_GROSSISTA_ORTOFRUTTA";
    RetailerType["FoodServiceGrossistaPesce"] = "FOOD_SERVICE_GROSSISTA_PESCE";
    RetailerType["FoodServiceGrossistaSurgelati"] = "FOOD_SERVICE_GROSSISTA_SURGELATI";
    RetailerType["IstituzioneCulturale"] = "ISTITUZIONE_CULTURALE";
    RetailerType["RetailCC"] = "RETAIL_C_C";
    RetailerType["RmaBroker"] = "RMA_BROKER";
    RetailerType["RmaCedec"] = "RMA_CEDEC";
    RetailerType["RmaCentraleDAcquisto"] = "RMA_CENTRALE_D_ACQUISTO";
    RetailerType["RmaConsorzio"] = "RMA_CONSORZIO";
    RetailerType["RmaECommerce"] = "RMA_E_COMMERCE";
    RetailerType["RmaGruppoInternazionale"] = "RMA_GRUPPO_INTERNAZIONALE";
    RetailerType["RmaGruppoNazionale"] = "RMA_GRUPPO_NAZIONALE";
    RetailerType["RmaGruppoRegionale"] = "RMA_GRUPPO_REGIONALE";
    RetailerType["RmaImportatore"] = "RMA_IMPORTATORE";
    RetailerType["RmaLandlord"] = "RMA_LANDLORD";
    RetailerType["RmaWholesaler"] = "RMA_WHOLESALER";
    RetailerType["RmsBroker"] = "RMS_BROKER";
    RetailerType["RmsCedec"] = "RMS_CEDEC";
    RetailerType["RmsCentraleDAcquisto"] = "RMS_CENTRALE_D_ACQUISTO";
    RetailerType["RmsConsorzio"] = "RMS_CONSORZIO";
    RetailerType["RmsECommerce"] = "RMS_E_COMMERCE";
    RetailerType["RmsGruppoInternazionale"] = "RMS_GRUPPO_INTERNAZIONALE";
    RetailerType["RmsGruppoNazionale"] = "RMS_GRUPPO_NAZIONALE";
    RetailerType["RmsGruppoRegionale"] = "RMS_GRUPPO_REGIONALE";
    RetailerType["RmsImportatore"] = "RMS_IMPORTATORE";
    RetailerType["RmsLandlord"] = "RMS_LANDLORD";
    RetailerType["RmsWholesaler"] = "RMS_WHOLESALER";
    RetailerType["VendingDistrLocale"] = "VENDING_DISTR_LOCALE";
    RetailerType["VendingDistributoreCentrale"] = "VENDING_DISTRIBUTORE_CENTRALE";
})(RetailerType || (exports.RetailerType = RetailerType = {}));
/** SampleRequest's possible statues */
var SampleRequestStatus;
(function (SampleRequestStatus) {
    SampleRequestStatus["Pending"] = "PENDING";
    SampleRequestStatus["Accepted"] = "ACCEPTED";
    SampleRequestStatus["Rejected"] = "REJECTED";
})(SampleRequestStatus || (exports.SampleRequestStatus = SampleRequestStatus = {}));
var ServiceOrderBy;
(function (ServiceOrderBy) {
    ServiceOrderBy["Name"] = "name";
    ServiceOrderBy["Type"] = "type";
})(ServiceOrderBy || (exports.ServiceOrderBy = ServiceOrderBy = {}));
/** Service possible types */
var ServiceType;
(function (ServiceType) {
    ServiceType["AttrezzatureFoodService"] = "ATTREZZATURE_FOOD_SERVICE";
    ServiceType["AttrezzatureRetail"] = "ATTREZZATURE_RETAIL";
    ServiceType["CentroMedia"] = "CENTRO_MEDIA";
    ServiceType["ConsulenzeFormazioneHR"] = "CONSULENZE_FORMAZIONE_H_R";
    ServiceType["Energia"] = "ENERGIA";
    ServiceType["EntiDiCertificazione"] = "ENTI_DI_CERTIFICAZIONE";
    ServiceType["Fiere"] = "FIERE";
    ServiceType["IstituzioneCulturale"] = "ISTITUZIONE_CULTURALE";
    ServiceType["MarketingPromoz"] = "MARKETING_PROMOZ";
    ServiceType["OrganiStatali"] = "ORGANI_STATALI";
    ServiceType["RealEstate"] = "REAL_ESTATE";
    ServiceType["RicercheDiMercato"] = "RICERCHE_DI_MERCATO";
    ServiceType["ScuoleEUniversit"] = "SCUOLE_E_UNIVERSIT";
    ServiceType["ServiziFinanziari"] = "SERVIZI_FINANZIARI";
    ServiceType["ServiziInformatici"] = "SERVIZI_INFORMATICI";
    ServiceType["ServiziLegali"] = "SERVIZI_LEGALI";
    ServiceType["ServiziLogistici"] = "SERVIZI_LOGISTICI";
    ServiceType["Telecomunicazioni"] = "TELECOMUNICAZIONI";
    ServiceType["UfficiStampaPR"] = "UFFICI_STAMPA_P_R";
})(ServiceType || (exports.ServiceType = ServiceType = {}));
/** Possible SocialTypes */
var SocialType;
(function (SocialType) {
    SocialType["Google"] = "GOOGLE";
    SocialType["Linkedin"] = "LINKEDIN";
    SocialType["Facebook"] = "FACEBOOK";
})(SocialType || (exports.SocialType = SocialType = {}));
var StateProvinceOrderByEnum;
(function (StateProvinceOrderByEnum) {
    StateProvinceOrderByEnum["Name"] = "name";
    StateProvinceOrderByEnum["NameIta"] = "nameIta";
    StateProvinceOrderByEnum["Region"] = "region";
    StateProvinceOrderByEnum["RegionIta"] = "regionIta";
    StateProvinceOrderByEnum["NielsenArea"] = "nielsenArea";
    StateProvinceOrderByEnum["Country"] = "Country";
})(StateProvinceOrderByEnum || (exports.StateProvinceOrderByEnum = StateProvinceOrderByEnum = {}));
var TargetMedia;
(function (TargetMedia) {
    TargetMedia["Website"] = "WEBSITE";
    TargetMedia["Newsletter"] = "NEWSLETTER";
})(TargetMedia || (exports.TargetMedia = TargetMedia = {}));
var TargetSite;
(function (TargetSite) {
    TargetSite["Ifn"] = "IFN";
    TargetSite["Hub"] = "HUB";
    TargetSite["Vote"] = "VOTE";
    TargetSite["Foodweb"] = "FOODWEB";
    TargetSite["Foodserviceweb"] = "FOODSERVICEWEB";
    TargetSite["Dolcesalato"] = "DOLCESALATO";
    TargetSite["Newsletter"] = "NEWSLETTER";
})(TargetSite || (exports.TargetSite = TargetSite = {}));
/** Transformation levels */
var TransformationLevel;
(function (TransformationLevel) {
    TransformationLevel["Unprepared"] = "UNPREPARED";
    TransformationLevel["Prepared"] = "PREPARED";
    TransformationLevel["PreparedNotReadyToEat"] = "PREPARED_NOT_READY_TO_EAT";
    TransformationLevel["PreparedReadyToEat"] = "PREPARED_READY_TO_EAT";
})(TransformationLevel || (exports.TransformationLevel = TransformationLevel = {}));
/** User note possible collections */
var UserNoteCollection;
(function (UserNoteCollection) {
    UserNoteCollection["Company"] = "Company";
    UserNoteCollection["Good"] = "Good";
    UserNoteCollection["Retailer"] = "Retailer";
    UserNoteCollection["CompanyGroup"] = "CompanyGroup";
    UserNoteCollection["Service"] = "Service";
    UserNoteCollection["FoodService"] = "FoodService";
})(UserNoteCollection || (exports.UserNoteCollection = UserNoteCollection = {}));
/** // TODO */
var UserObjectSubscriptionFlag;
(function (UserObjectSubscriptionFlag) {
    UserObjectSubscriptionFlag["Bookmark"] = "BOOKMARK";
    UserObjectSubscriptionFlag["Follow"] = "FOLLOW";
})(UserObjectSubscriptionFlag || (exports.UserObjectSubscriptionFlag = UserObjectSubscriptionFlag = {}));
var UserOrderBy;
(function (UserOrderBy) {
    UserOrderBy["FirstName"] = "firstName";
    UserOrderBy["LastName"] = "lastName";
    UserOrderBy["Email"] = "email";
    UserOrderBy["Status"] = "status";
    UserOrderBy["Role"] = "role";
    UserOrderBy["CreatedOn"] = "createdOn";
    UserOrderBy["LastLogin"] = "lastLogin";
})(UserOrderBy || (exports.UserOrderBy = UserOrderBy = {}));
/** User possible roles */
var UserRole;
(function (UserRole) {
    UserRole["Anonymus"] = "ANONYMUS";
    UserRole["Internal"] = "INTERNAL";
    UserRole["Producer"] = "PRODUCER";
    UserRole["Buyer"] = "BUYER";
    UserRole["BuyerPlItalia"] = "BUYER_PL_ITALIA";
    UserRole["Foodservice"] = "FOODSERVICE";
    UserRole["Shopworker"] = "SHOPWORKER";
    UserRole["Service"] = "SERVICE";
    UserRole["Consumer"] = "CONSUMER";
})(UserRole || (exports.UserRole = UserRole = {}));
/** User statuses */
var UserStatus;
(function (UserStatus) {
    UserStatus["NotVerified"] = "NOT_VERIFIED";
    UserStatus["WaitingReview"] = "WAITING_REVIEW";
    UserStatus["Active"] = "ACTIVE";
    UserStatus["Disabled"] = "DISABLED";
    UserStatus["Deleted"] = "DELETED";
})(UserStatus || (exports.UserStatus = UserStatus = {}));
/** User possible relations used for visibility */
var VisibilityRelations;
(function (VisibilityRelations) {
    VisibilityRelations["LinkedToFair"] = "LINKED_TO_FAIR";
    VisibilityRelations["LinkedToAwardCandidacy"] = "LINKED_TO_AWARD_CANDIDACY";
    VisibilityRelations["LinkedToAwardEvent"] = "LINKED_TO_AWARD_EVENT";
    VisibilityRelations["LinkedToAwardVote"] = "LINKED_TO_AWARD_VOTE";
    VisibilityRelations["LinkedToCompany"] = "LINKED_TO_COMPANY";
    VisibilityRelations["LinkedToGeoIndication"] = "LINKED_TO_GEO_INDICATION";
    VisibilityRelations["TargetForFair"] = "TARGET_FOR_FAIR";
    VisibilityRelations["TargetForAwardCandidacy"] = "TARGET_FOR_AWARD_CANDIDACY";
    VisibilityRelations["TargetForAwardEvent"] = "TARGET_FOR_AWARD_EVENT";
    VisibilityRelations["TargetForAwardVote"] = "TARGET_FOR_AWARD_VOTE";
    VisibilityRelations["TargetForCompany"] = "TARGET_FOR_COMPANY";
    VisibilityRelations["TargetForGeoIndication"] = "TARGET_FOR_GEO_INDICATION";
})(VisibilityRelations || (exports.VisibilityRelations = VisibilityRelations = {}));
/** User possible roles used for visibility */
var VisibilityRole;
(function (VisibilityRole) {
    VisibilityRole["AnonymusOnly"] = "ANONYMUS_ONLY";
    VisibilityRole["UserOnly"] = "USER_ONLY";
    VisibilityRole["ProducerOnly"] = "PRODUCER_ONLY";
    VisibilityRole["BuyerOnly"] = "BUYER_ONLY";
})(VisibilityRole || (exports.VisibilityRole = VisibilityRole = {}));
var VisibilityType;
(function (VisibilityType) {
    VisibilityType["Anonymus"] = "ANONYMUS";
    VisibilityType["User"] = "USER";
    VisibilityType["Pardot"] = "PARDOT";
    VisibilityType["Typeform"] = "TYPEFORM";
    VisibilityType["SfItem"] = "SF_ITEM";
    VisibilityType["SfCampaign"] = "SF_CAMPAIGN";
    VisibilityType["SfCampaignPresente"] = "SF_CAMPAIGN_PRESENTE";
})(VisibilityType || (exports.VisibilityType = VisibilityType = {}));
/** // TODO */
var WidgetLocation;
(function (WidgetLocation) {
    WidgetLocation["Homepage"] = "HOMEPAGE";
    WidgetLocation["Dashboard"] = "DASHBOARD";
    WidgetLocation["EditorialSection"] = "EDITORIAL_SECTION";
    WidgetLocation["FairDirectory"] = "FAIR_DIRECTORY";
    WidgetLocation["SupplierDirectory"] = "SUPPLIER_DIRECTORY";
    WidgetLocation["ProductDirectory"] = "PRODUCT_DIRECTORY";
})(WidgetLocation || (exports.WidgetLocation = WidgetLocation = {}));
var WidgetOrderBy;
(function (WidgetOrderBy) {
    WidgetOrderBy["Name"] = "name";
    WidgetOrderBy["StartDate"] = "startDate";
    WidgetOrderBy["ExpirationDate"] = "expirationDate";
    WidgetOrderBy["OrderPriority"] = "orderPriority";
})(WidgetOrderBy || (exports.WidgetOrderBy = WidgetOrderBy = {}));
/** // TODO */
var WidgetStyleColor;
(function (WidgetStyleColor) {
    WidgetStyleColor["Primary"] = "PRIMARY";
    WidgetStyleColor["Secondary"] = "SECONDARY";
    WidgetStyleColor["Alt"] = "ALT";
    WidgetStyleColor["Alt2"] = "ALT2";
    WidgetStyleColor["ByEditorialSection"] = "BY_EDITORIAL_SECTION";
    WidgetStyleColor["Gradient1"] = "GRADIENT1";
    WidgetStyleColor["Gradient2"] = "GRADIENT2";
})(WidgetStyleColor || (exports.WidgetStyleColor = WidgetStyleColor = {}));
/** // TODO */
var WidgetStyleType;
(function (WidgetStyleType) {
    WidgetStyleType["Bordered"] = "BORDERED";
    WidgetStyleType["Unboxed"] = "UNBOXED";
    WidgetStyleType["Magazine"] = "MAGAZINE";
    WidgetStyleType["Big_4Small"] = "BIG_4SMALL";
    WidgetStyleType["Carusel"] = "CARUSEL";
})(WidgetStyleType || (exports.WidgetStyleType = WidgetStyleType = {}));
//# sourceMappingURL=server-types.js.map